<template>
  <section id="delivery-date-dashboard">
    <!-- Headline figures -->
    <b-row class="stats-overview-row mb-1">
      <b-col xl md="6" class="mb-1">
        <div class="modern-stat-card animate-fade-in" role="button" tabindex="0"
          @click="onCardClick('support_overdue')" @keydown.enter="onCardClick('support_overdue')">
          <div class="stat-icon-wrapper gradient-danger">
            <feather-icon icon="AlertTriangleIcon" size="28" />
          </div>
          <div class="stat-content">
            <div class="stat-header">
              <h5 class="stat-title">
                {{ $t('delivery.cards.supportOverdue.title') }}
              </h5>
            </div>
            <div class="stat-value-wrapper">
              <h2 class="stat-main-value">
                {{ summary.support_overdue }}
              </h2>
              <div class="stat-sub-value">
                {{ $t('delivery.cards.paidUnpaid', { paid: summary.support_overdue - summary.support_overdue_unpaid, unpaid: summary.support_overdue_unpaid }) }}
              </div>
              <div class="stat-hint">
                <span class="stat-hint-who">{{ $t('delivery.cards.supportOverdue.who') }}</span> — {{ $t('delivery.cards.supportOverdue.hint') }}
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col xl md="6" class="mb-1">
        <div class="modern-stat-card animate-fade-in" role="button" tabindex="0"
          @click="onCardClick('definitely_late')" @keydown.enter="onCardClick('definitely_late')">
          <div class="stat-icon-wrapper gradient-danger">
            <feather-icon icon="AlertOctagonIcon" size="28" />
          </div>
          <div class="stat-content">
            <div class="stat-header">
              <h5 class="stat-title">
                {{ $t('delivery.cards.definitelyLate.title') }}
              </h5>
            </div>
            <div class="stat-value-wrapper">
              <h2 class="stat-main-value">
                {{ summary.support_definitely_late }}
              </h2>
              <div class="stat-sub-value">
                {{ $t('delivery.cards.paidUnpaid', { paid: summary.support_definitely_late - summary.support_definitely_late_unpaid, unpaid: summary.support_definitely_late_unpaid }) }}
              </div>
              <div class="stat-hint">
                <span class="stat-hint-who">{{ $t('delivery.cards.definitelyLate.who') }}</span> — {{ $t('delivery.cards.definitelyLate.hint') }}
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col xl md="6" class="mb-1">
        <div class="modern-stat-card animate-fade-in" role="button" tabindex="0"
          @click="onCardClick('support_no_date')" @keydown.enter="onCardClick('support_no_date')">
          <div class="stat-icon-wrapper gradient-info">
            <feather-icon icon="HelpCircleIcon" size="28" />
          </div>
          <div class="stat-content">
            <div class="stat-header">
              <h5 class="stat-title">
                {{ $t('delivery.cards.noDate.title') }}
              </h5>
            </div>
            <div class="stat-value-wrapper">
              <h2 class="stat-main-value">
                {{ summary.support_no_date }}
              </h2>
              <div class="stat-sub-value">
                {{ $t('delivery.cards.paidUnpaid', { paid: summary.support_no_date - summary.support_no_date_unpaid, unpaid: summary.support_no_date_unpaid }) }}
              </div>
              <div class="stat-hint">
                <span class="stat-hint-who">{{ $t('delivery.cards.noDate.who') }}</span> — {{ $t('delivery.cards.noDate.hint') }}
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col xl md="6" class="mb-1">
        <div class="modern-stat-card animate-fade-in" role="button" tabindex="0"
          @click="onCardClick('purchasing_overdue')" @keydown.enter="onCardClick('purchasing_overdue')">
          <div class="stat-icon-wrapper gradient-warning">
            <feather-icon icon="TruckIcon" size="28" />
          </div>
          <div class="stat-content">
            <div class="stat-header">
              <h5 class="stat-title">
                {{ $t('delivery.cards.purchasingOverdue.title') }}
              </h5>
            </div>
            <div class="stat-value-wrapper">
              <h2 class="stat-main-value">
                {{ summary.purchasing_overdue }}
              </h2>
              <div class="stat-hint">
                <span class="stat-hint-who">{{ $t('delivery.cards.purchasingOverdue.who') }}</span> — {{ $t('delivery.cards.purchasingOverdue.hint') }}
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col xl md="6" class="mb-1">
        <div class="modern-stat-card animate-fade-in" role="button" tabindex="0"
          @click="onCardClick('lb_unconfirmed')" @keydown.enter="onCardClick('lb_unconfirmed')">
          <div class="stat-icon-wrapper gradient-primary">
            <feather-icon icon="ClockIcon" size="28" />
          </div>
          <div class="stat-content">
            <div class="stat-header">
              <h5 class="stat-title">
                {{ $t('delivery.cards.lbUnconfirmed.title') }}
              </h5>
            </div>
            <div class="stat-value-wrapper">
              <h2 class="stat-main-value">
                {{ summary.lb_unconfirmed }}
              </h2>
              <div class="stat-hint">
                <span class="stat-hint-who">{{ $t('delivery.cards.lbUnconfirmed.who') }}</span> — {{ $t('delivery.cards.lbUnconfirmed.hint') }}
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col xl md="6" class="mb-1">
        <div class="modern-stat-card animate-fade-in" role="button" tabindex="0"
          @click="onCardClick('backorder')" @keydown.enter="onCardClick('backorder')">
          <div class="stat-icon-wrapper gradient-danger">
            <feather-icon icon="ArchiveIcon" size="28" />
          </div>
          <div class="stat-content">
            <div class="stat-header">
              <h5 class="stat-title">
                {{ $t('delivery.cards.backorder.title') }}
              </h5>
            </div>
            <div class="stat-value-wrapper">
              <h2 class="stat-main-value">
                {{ summary.backorder_danger }}
              </h2>
              <div class="stat-sub-value">
                {{ $t('delivery.cards.backorder.sub', { warn: summary.backorder_warn, stock: summary.backorder_supplier_stock }) }}
              </div>
              <div class="stat-hint">
                <span class="stat-hint-who">{{ $t('delivery.cards.backorder.who') }}</span> — {{ $t('delivery.cards.backorder.hint') }}
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-tabs v-model="activeTab" @input="onTabChange">
      <!-- Search and Filter Section (shared across the Purchasing/Support tabs, below
           the tab bar). Meaningless on the Statistics tab (no owner/date/status filters
           there), so it's hidden rather than shown-but-inert. -->
      <b-card v-if="activeTab !== 2" class="mb-2">
        <b-card-header>
          <h5>
            <feather-icon icon="FilterIcon" size="20" class="mr-50" />
            {{ $t('delivery.filters.title') }}
          </h5>
          <p class="mb-0 text-muted">{{ $t('delivery.filters.subtitle') }}</p>
          <b-button variant="outline-secondary" size="sm" class="ml-auto" @click="clearFilters">
            <feather-icon icon="XIcon" size="14" class="mr-25" />
            {{ $t('delivery.filters.clearAll') }}
          </b-button>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col xl="3" lg="4" md="6" class="mb-md-1">
              <b-form-group :label="$t('delivery.filters.search')" label-for="dd-search">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" size="14" />
                  </b-input-group-prepend>
                  <b-form-input id="dd-search" v-model="searchValue" type="search" :placeholder="$t('delivery.filters.searchPlaceholder')"
                    @keyup.enter="applyFilters" />
                </b-input-group>
                <small class="text-muted">
                  {{ $t('delivery.filters.searchHint') }}
                </small>
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="4" md="6" sm="6">
              <b-form-group :label="$t('delivery.filters.owner')" label-for="dd-owner">
                <v-select id="dd-owner" v-model="selectedOwner" label="title" :options="ownerOptions" :placeholder="$t('delivery.common.all')"
                  :clearable="true" :disabled="onlyMine" @input="applyFilters" />
              </b-form-group>
            </b-col>
            <b-col xl="2" lg="3" md="4" sm="6">
              <b-form-group :label="$t('delivery.filters.createdAfter')" label-for="dd-created">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="CalendarIcon" size="14" />
                  </b-input-group-prepend>
                  <flat-pickr id="dd-created" v-model="createdAfter" :placeholder="$t('delivery.common.optional')" class="form-control"
                    @on-change="applyFilters" />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="4" md="6" sm="6">
              <b-form-group :label="$t('delivery.filters.status')" label-for="dd-status">
                <v-select id="dd-status" v-model="activeStatuses" label="title" :options="statusOptions" multiple
                  :close-on-select="false" :placeholder="$t('delivery.common.any')" @input="applyFilters" />
              </b-form-group>
            </b-col>
            <b-col xl="2" lg="3" md="4" sm="6">
              <b-form-group :label="$t('delivery.filters.noDateAge')" label-for="dd-days">
                <b-form-input id="dd-days" v-model.number="daysNoDate" type="number" min="0" @change="applyFilters" />
              </b-form-group>
            </b-col>
            <b-col xl="2" lg="3" md="4" sm="6">
              <b-form-group :label="$t('delivery.filters.options')" label-for="dd-only-mine">
                <b-form-checkbox id="dd-only-mine" v-model="onlyMine" switch class="mt-50" @change="applyFilters">
                  {{ $t('delivery.filters.onlyMine') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="activeTab === 1">
            <b-col xl="3" lg="4" md="6" sm="6">
              <b-form-group :label="$t('delivery.filters.platform')" label-for="dd-platform">
                <v-select id="dd-platform" v-model="selectedPlatform" label="title" :options="platformOptions"
                  :placeholder="$t('delivery.common.all')" :clearable="true" @input="applyFilters" />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="4" md="6" sm="6">
              <b-form-group :label="$t('delivery.filters.countryGroup')" label-for="dd-country-group">
                <v-select id="dd-country-group" v-model="selectedCountryGroup" label="text" :options="countryGroupOptions"
                  :reduce="o => o.value" multiple :placeholder="$t('delivery.common.all')" :clearable="true" @input="applyFilters" />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="4" md="6" sm="6">
              <b-form-group :label="$t('delivery.filters.priority')" label-for="dd-priority">
                <v-select id="dd-priority" v-model="selectedPriority" label="text" :options="priorityOptions"
                  :reduce="o => o.value" multiple :close-on-select="false" :placeholder="$t('delivery.common.all')" @input="applyFilters" />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="4" md="6" sm="6">
              <b-form-group :label="$t('delivery.filters.payment')" label-for="dd-payment">
                <v-select id="dd-payment" v-model="paymentModel" label="title" :options="paymentOptions"
                  :placeholder="$t('delivery.common.all')" :clearable="true" @input="applyFilters" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
        <hr class="m-0">
        <b-card-body class="py-1">
          <div class="d-flex flex-wrap align-items-center">
            <small class="text-muted font-weight-bold mr-1">{{ $t('delivery.legend.title') }}</small>
            <b-badge variant="secondary" class="mr-50 mb-25">{{ $t('delivery.legend.noDate') }}</b-badge>
            <b-badge variant="danger" class="mr-50 mb-25">{{ $t('delivery.legend.overdue') }}</b-badge>
            <b-badge variant="warning" class="mr-50 mb-25">{{ $t('delivery.legend.todayTomorrow') }}</b-badge>
            <b-badge style="background-color:#f1c40f;color:#000" class="mr-50 mb-25">{{ $t('delivery.legend.thisWeek') }}</b-badge>
            <b-badge variant="success" class="mr-50 mb-25">{{ $t('delivery.legend.later') }}</b-badge>
            <b-badge variant="secondary" class="mb-25">{{ $t('delivery.legend.closed') }}</b-badge>
          </div>
        </b-card-body>
      </b-card>

      <!-- ===================== PURCHASING (E1/E2/E3/E4) ===================== -->
      <b-tab :title="$t('delivery.tabs.purchasing')">
        <backorder-list ref="backorderList" :lb-no="summary.backorder_lb_no" />

        <!-- E4 -->
        <b-card ref="e4Card">
          <b-card-header :class="{ 'critical-header': e4Count > 0 }">
            <h4 class="mb-0">
              <feather-icon icon="AlertTriangleIcon" size="20" class="mr-50" />
              {{ $t('delivery.e4.title') }}
              <b-badge v-if="e4Count > 0" variant="danger" class="ml-50">{{ e4Count }}</b-badge>
            </h4>
            <p class="mb-0 text-muted">
              {{ $t('delivery.e4.desc') }}
            </p>
            <div style="margin-left: auto;">
              <feather-icon icon="DownloadIcon" size="21" class="text-muted cursor-pointer" @click="exportList('e4')" />
            </div>
          </b-card-header>
          <b-card-body class="card-body-table">
            <b-table striped hover responsive class="position-relative clickable-rows" :current-page="e4.currentPage"
              :items="e4.items" :fields="tableFields.e4" :sort-by.sync="e4.sortBy" :sort-desc.sync="e4.sortDesc"
              @sort-changed="s => sortChanged('e4', s)" @row-clicked="item => openDetail('order', item)">
              <template #cell(order_no)="row">
                <span class="copy-no" :title="$t('delivery.common.clickToCopy')" @click.stop="copy(row.item.order_no)">
                  {{ row.item.order_no }} <feather-icon icon="CopyIcon" size="12" />
                </span>
              </template>
              <template #cell(age_days)="row">
                <b-badge v-if="ageVariant(row.item.age_days)" v-b-tooltip.hover.top="ageTooltip(row.item)"
                  :variant="ageVariant(row.item.age_days)">
                  {{ row.item.age_days }} {{ $t('delivery.common.daysShort') }}
                </b-badge>
                <span v-else v-b-tooltip.hover.top="ageTooltip(row.item)">{{ row.item.age_days }}</span>
              </template>
              <template #cell(suggestion_reason)="row">
                <b-badge v-if="row.item.suggestion_reason === 'needs_purchasing'" variant="light-danger"
                  :title="$t('delivery.tips.needsPurchasing')">
                  {{ $t('delivery.states.needsPurchasingNothingOrdered') }}
                </b-badge>
                <template v-else-if="row.item.suggestion_reason === 'supplier_overdue'">
                  <b-badge variant="light-danger"
                    :title="$t('delivery.tips.supplierOverdue')">
                    {{ $t('delivery.states.supplierOverdue') }}
                  </b-badge>
                  <small v-if="row.item.suggestion_lb_no" class="text-muted d-block">{{ row.item.suggestion_lb_no }}</small>
                </template>
                <span v-else class="text-muted">—</span>
              </template>
              <template #cell(hold)="row">
                <template v-if="row.item.on_hold">
                  <b-badge variant="light-warning" :title="$t('delivery.tips.heldBack')">
                    {{ $t('delivery.states.onHold') }}
                  </b-badge>
                  <small v-if="row.item.hold_reason" class="text-muted d-block">{{ row.item.hold_reason }}</small>
                </template>
                <span v-else class="text-muted">—</span>
              </template>
              <template #cell(notes)="row">
                <span :title="row.item.notes || ''">{{ row.value }}</span>
              </template>
            </b-table>
            <pagination-bar :table="e4" @change="v => pageChange('e4', v)" />
          </b-card-body>
        </b-card>

        <!-- E1 -->
        <b-card ref="e1Card">
          <b-card-header>
            <h4 class="mb-0">
              <feather-icon icon="TruckIcon" size="20" class="mr-50" />
              {{ $t('delivery.e1.title') }}
            </h4>
            <p class="mb-0 text-muted">{{ $t('delivery.e1.desc') }}</p>
            <div style="margin-left: auto;">
              <feather-icon icon="DownloadIcon" size="21" class="text-muted cursor-pointer" @click="exportList('e1')" />
            </div>
          </b-card-header>
          <b-card-body class="card-body-table">
            <b-table striped hover responsive class="position-relative clickable-rows" :current-page="e1.currentPage"
              :items="e1.items" :fields="tableFields.e1" :sort-by.sync="e1.sortBy" :sort-desc.sync="e1.sortDesc"
              :tbody-tr-class="e1RowClass" @sort-changed="s => sortChanged('e1', s)"
              @row-clicked="item => openDetail('lb', item)">
              <template #cell(order_no)="row">
                <span class="copy-no" :title="$t('delivery.common.clickToCopy')" @click.stop="copy(row.item.order_no)">
                  {{ row.item.order_no }} <feather-icon icon="CopyIcon" size="12" />
                </span>
              </template>
              <template #cell(pos_summary)="row">
                <b-badge v-if="row.item.pos_no_date > 0" variant="light-secondary">
                  {{ $t('delivery.e1.posWithoutDate', { n: row.item.pos_no_date, total: row.item.pos_total }) }}
                </b-badge>
                <span v-else>{{ $t('delivery.e1.posShort', { n: row.item.pos_total }) }}</span>
              </template>
              <template #cell(status)="row">
                <b-badge :variant="lightVariant(row.item)">
                  {{ statusLabel(row.item) }}
                </b-badge>
                <b-badge v-if="row.item.blocks_late_order" variant="danger" class="ml-25"
                  :title="$t('delivery.e1.blocksTitle', { order: row.item.blocked_order_no, date: fmtDate(row.item.blocked_promised_date) || $t('delivery.e1.na') })">
                  {{ $t('delivery.e1.blocks', { order: row.item.blocked_order_no }) }}
                </b-badge>
              </template>
              <template #cell(notes)="row">
                <span :title="row.item.notes || ''">{{ row.value }}</span>
              </template>
            </b-table>
            <pagination-bar :table="e1" @change="v => pageChange('e1', v)" />
          </b-card-body>
        </b-card>

        <!-- E2 -->
        <b-card ref="e2Card">
          <b-card-header>
            <h4 class="mb-0">
              <feather-icon icon="ClockIcon" size="20" class="mr-50" />
              {{ $t('delivery.e2.title') }}
            </h4>
            <p class="mb-0 text-muted">{{ $t('delivery.e2.desc') }}</p>
            <div style="margin-left: auto;">
              <feather-icon icon="DownloadIcon" size="21" class="text-muted cursor-pointer" @click="exportList('e2')" />
            </div>
          </b-card-header>
          <b-card-body class="card-body-table">
            <b-table striped hover responsive class="position-relative clickable-rows" :current-page="e2.currentPage"
              :items="e2.items" :fields="tableFields.e2" :sort-by.sync="e2.sortBy" :sort-desc.sync="e2.sortDesc"
              :tbody-tr-class="e2RowClass" @sort-changed="s => sortChanged('e2', s)"
              @row-clicked="item => openDetail('lb', item)">
              <template #cell(order_no)="row">
                <span class="copy-no" :title="$t('delivery.common.clickToCopy')" @click.stop="copy(row.item.order_no)">
                  {{ row.item.order_no }} <feather-icon icon="CopyIcon" size="12" />
                </span>
              </template>
              <template #cell(notes)="row">
                <span :title="row.item.notes || ''">{{ row.value }}</span>
              </template>
            </b-table>
            <pagination-bar :table="e2" @change="v => pageChange('e2', v)" />
          </b-card-body>
        </b-card>

        <!-- E3 -->
        <b-card>
          <b-card-header>
            <h4 class="mb-0">
              <feather-icon icon="HelpCircleIcon" size="20" class="mr-50" />
              {{ $t('delivery.e3.title') }}
            </h4>
            <p class="mb-0 text-muted">{{ $t('delivery.e3.desc') }}</p>
            <div style="margin-left: auto;">
              <feather-icon icon="DownloadIcon" size="21" class="text-muted cursor-pointer" @click="exportList('e3')" />
            </div>
          </b-card-header>
          <b-card-body class="card-body-table">
            <b-table striped hover responsive class="position-relative clickable-rows" :current-page="e3.currentPage"
              :items="e3.items" :fields="tableFields.e3" :sort-by.sync="e3.sortBy" :sort-desc.sync="e3.sortDesc"
              @sort-changed="s => sortChanged('e3', s)" @row-clicked="item => openDetail('lb', item)">
              <template #cell(order_no)="row">
                <span class="copy-no" :title="$t('delivery.common.clickToCopy')" @click.stop="copy(row.item.order_no)">
                  {{ row.item.order_no }} <feather-icon icon="CopyIcon" size="12" />
                </span>
              </template>
              <template #cell(notes)="row">
                <span :title="row.item.notes || ''">{{ row.value }}</span>
              </template>
            </b-table>
            <pagination-bar :table="e3" @change="v => pageChange('e3', v)" />
          </b-card-body>
        </b-card>
      </b-tab>

      <!-- ===================== SUPPORT (S1/S2) ===================== -->
      <b-tab :title="$t('delivery.tabs.support')">
        <!-- S1 -->
        <b-card ref="s1Card">
          <b-card-header>
            <h4 class="mb-0">
              <feather-icon icon="UserIcon" size="20" class="mr-50" />
              {{ $t('delivery.s1.title') }}
            </h4>
            <p class="mb-0 text-muted">
              {{ $t('delivery.s1.desc') }}
            </p>
            <div style="margin-left: auto;">
              <feather-icon icon="DownloadIcon" size="21" class="text-muted cursor-pointer" @click="exportList('s1')" />
            </div>
          </b-card-header>
          <b-card-body class="card-body-table">
            <b-table striped hover responsive class="position-relative clickable-rows" :current-page="s1.currentPage"
              :items="s1.items" :fields="tableFields.s1" :sort-by.sync="s1.sortBy" :sort-desc.sync="s1.sortDesc"
              :tbody-tr-class="s1RowClass" @sort-changed="s => sortChanged('s1', s)"
              @row-clicked="item => openDetail('order', item)">
              <template #cell(order_no)="row">
                <span class="copy-no" :title="$t('delivery.common.clickToCopy')" @click.stop="copy(row.item.order_no)">
                  {{ row.item.order_no }} <feather-icon icon="CopyIcon" size="12" />
                </span>
              </template>
              <template #cell(source)="row">
                <b-badge :variant="row.item.is_manual ? 'light-warning' : 'light-info'">
                  {{ row.item.source }}
                </b-badge>
              </template>
              <template #cell(age_days)="row">
                <b-badge v-if="ageVariant(row.item.age_days)" v-b-tooltip.hover.top="ageTooltip(row.item)"
                  :variant="ageVariant(row.item.age_days)">
                  {{ row.item.age_days }} {{ $t('delivery.common.daysShort') }}
                </b-badge>
                <span v-else v-b-tooltip.hover.top="ageTooltip(row.item)">{{ row.item.age_days }}</span>
              </template>
              <!-- Latest supplier arrival across the order's positions (ship-complete date) —
                   closed rows and rows with no incoming_state (fillna may send 0) read as a
                   dash. Hover shows the per-position breakdown via loadIncomingPopover. -->
              <template #cell(incoming_date)="row">
                <span v-if="row.item.is_closed || !row.item.incoming_state || row.item.incoming_state === 'no_data'" class="text-muted">—</span>
                <template v-else>
                  <span :id="incomingCellId('s1', row.item.order_no)">
                    <template v-if="row.item.incoming_state === 'incoming'">
                      <b-badge v-if="row.item.incoming_after_promise" variant="light-danger"
                        :title="$t('delivery.tips.arrivalAfterPromise')">
                        {{ fmtDate(row.item.incoming_date) }}
                      </b-badge>
                      <span v-else>{{ fmtDate(row.item.incoming_date) }}</span>
                    </template>
                    <b-badge v-else-if="row.item.incoming_state === 'stock'" variant="light-success">{{ $t('delivery.states.inStock') }}</b-badge>
                    <template v-else-if="row.item.incoming_state === 'unconfirmed'">
                      <b-badge variant="light-warning">{{ $t('delivery.states.unconfirmed') }}</b-badge>
                      <small v-if="row.item.incoming_lb_no" class="text-muted d-block">{{ row.item.incoming_lb_no }}</small>
                    </template>
                    <template v-else-if="row.item.incoming_state === 'supplier_overdue'">
                      <b-badge variant="light-danger">{{ $t('delivery.states.supplierOverdue') }}</b-badge>
                      <small v-if="row.item.incoming_lb_no" class="text-muted d-block">{{ row.item.incoming_lb_no }}</small>
                    </template>
                    <b-badge v-else-if="row.item.incoming_state === 'needs_purchasing'" variant="light-danger">
                      {{ $t('delivery.states.notOrdered') }}
                    </b-badge>
                  </span>
                  <b-popover :target="incomingCellId('s1', row.item.order_no)" triggers="hover" placement="top"
                    boundary="viewport" custom-class="incoming-popover" :title="$t('delivery.popover.title')" @show="loadIncomingPopover(row.item.order_no)">
                    <b-spinner v-if="incomingEntry(row.item.order_no).loading" small />
                    <span v-else-if="incomingEntry(row.item.order_no).error" class="text-danger">
                      {{ $t('delivery.popover.error') }}
                    </span>
                    <template v-else>
                      <div v-for="(line, idx) in incomingEntry(row.item.order_no).lines" :key="idx"
                        class="d-flex justify-content-between incoming-popover-line">
                        <span class="mr-1">{{ line.sku }} × {{ line.qty }}</span>
                        <span :class="line.variant ? `text-${line.variant}` : ''">{{ line.text }}</span>
                      </div>
                      <div v-if="!incomingEntry(row.item.order_no).lines.length" class="text-muted small">
                        {{ $t('delivery.popover.none') }}
                      </div>
                    </template>
                    <small class="text-muted d-block mt-50">
                      {{ $t('delivery.popover.matched') }}
                    </small>
                  </b-popover>
                  <div v-if="row.item.partial_delivery" class="mt-25">
                    <b-badge v-b-tooltip.hover.top="partialLabel(row.item)" variant="light-primary">{{ $t('delivery.states.partialDelivery') }}</b-badge>
                  </div>
                </template>
              </template>
              <template #cell(status)="row">
                <b-badge :variant="lightVariant(row.item)">
                  {{ statusLabel(row.item) }}
                </b-badge>
                <b-badge v-if="!row.item.is_closed && row.item.late_severity === 2" variant="danger" class="ml-25"
                  :title="row.item.definitely_late
                    ? $t('delivery.tips.definitelyLate')
                    : $t('delivery.tips.promisePassed')">
                  {{ $t('delivery.e1.lateAction') }}
                </b-badge>
                <b-badge v-else-if="!row.item.is_closed && row.item.late_severity === 1" variant="light-danger" class="ml-25"
                  :title="$t('delivery.tips.supplierArrivalOverdue')">
                  {{ $t('delivery.states.supplierOverdue') }}
                </b-badge>
              </template>
              <template #cell(hold)="row">
                <template v-if="row.item.on_hold">
                  <b-badge variant="light-warning" :title="$t('delivery.tips.heldBack')">
                    {{ $t('delivery.states.onHold') }}
                  </b-badge>
                  <small v-if="row.item.hold_reason" class="text-muted d-block">{{ row.item.hold_reason }}</small>
                </template>
                <span v-else class="text-muted">—</span>
              </template>
              <template #cell(priority)="row">
                <b-badge v-if="priorityVariant(row.item.priority)" :variant="priorityVariant(row.item.priority)">
                  {{ row.item.priority }}
                </b-badge>
                <span v-else>{{ row.item.priority }}</span>
              </template>
              <template #cell(payment_status)="row">
                <b-badge :variant="paymentVariant(row.item.payment_status)">
                  {{ paymentLabel(row.item.payment_status) }}
                </b-badge>
                <div v-if="row.item.paid_date" class="small text-nowrap">
                  {{ fmtDate(row.item.paid_date) }}
                </div>
              </template>
              <template #cell(notes)="row">
                <span :title="row.item.notes || ''">{{ row.value }}</span>
              </template>
            </b-table>
            <pagination-bar :table="s1" @change="v => pageChange('s1', v)" />
          </b-card-body>
        </b-card>

        <!-- S2 -->
        <b-card ref="s2Card">
          <b-card-header>
            <h4 class="mb-0">
              <feather-icon icon="HelpCircleIcon" size="20" class="mr-50" />
              {{ $t('delivery.s2.title', { days: daysNoDate }) }}
            </h4>
            <p class="mb-0 text-muted">{{ $t('delivery.s2.desc') }}</p>
            <div style="margin-left: auto;">
              <feather-icon icon="DownloadIcon" size="21" class="text-muted cursor-pointer" @click="exportList('s2')" />
            </div>
          </b-card-header>
          <b-card-body class="card-body-table">
            <!-- 24h auto-apply info line (stock/incoming suggestions only). -->
            <div class="mb-1 d-flex align-items-center flex-wrap">
              <small class="text-muted mr-50">{{ autoApplyInfoText }}</small>
              <b-button variant="link" size="sm" class="p-0 align-baseline" @click="toggleAutoQueue">
                {{ showAutoQueue ? $t('delivery.auto.hideReview') : $t('delivery.auto.showReview') }}
              </b-button>
            </div>
            <b-table striped hover responsive class="position-relative clickable-rows" :current-page="s2.currentPage"
              :items="s2.items" :fields="tableFields.s2" :sort-by.sync="s2.sortBy" :sort-desc.sync="s2.sortDesc"
              @sort-changed="s => sortChanged('s2', s)" @row-clicked="item => openDetail('order', item)">
              <template #cell(order_no)="row">
                <span class="copy-no" :title="$t('delivery.common.clickToCopy')" @click.stop="copy(row.item.order_no)">
                  {{ row.item.order_no }} <feather-icon icon="CopyIcon" size="12" />
                </span>
              </template>
              <template #cell(source)="row">
                <b-badge :variant="row.item.is_manual ? 'light-warning' : 'light-info'">
                  {{ row.item.source }}
                </b-badge>
              </template>
              <template #cell(age_days)="row">
                <b-badge v-if="ageVariant(row.item.age_days)" v-b-tooltip.hover.top="ageTooltip(row.item)"
                  :variant="ageVariant(row.item.age_days)">
                  {{ row.item.age_days }} {{ $t('delivery.common.daysShort') }}
                </b-badge>
                <span v-else v-b-tooltip.hover.top="ageTooltip(row.item)">{{ row.item.age_days }}</span>
              </template>
              <template #cell(hold)="row">
                <template v-if="row.item.on_hold">
                  <b-badge variant="light-warning" :title="$t('delivery.tips.heldBack')">
                    {{ $t('delivery.states.onHold') }}
                  </b-badge>
                  <small v-if="row.item.hold_reason" class="text-muted d-block">{{ row.item.hold_reason }}</small>
                </template>
                <span v-else class="text-muted">—</span>
              </template>
              <template #cell(priority)="row">
                <b-badge v-if="priorityVariant(row.item.priority)" :variant="priorityVariant(row.item.priority)">
                  {{ row.item.priority }}
                </b-badge>
                <span v-else>{{ row.item.priority }}</span>
              </template>
              <template #cell(payment_status)="row">
                <b-badge :variant="paymentVariant(row.item.payment_status)">
                  {{ paymentLabel(row.item.payment_status) }}
                </b-badge>
                <div v-if="row.item.paid_date" class="small text-nowrap">
                  {{ fmtDate(row.item.paid_date) }}
                </div>
              </template>
              <!-- Same rendering as S1's incoming_date cell (see there for the rule set);
                   S2 rows never carry incoming_after_promise (S1-only), so 'incoming' is
                   always the plain date here. -->
              <template #cell(incoming_date)="row">
                <span v-if="!row.item.incoming_state || row.item.incoming_state === 'no_data'" class="text-muted">—</span>
                <template v-else>
                  <span :id="incomingCellId('s2', row.item.order_no)">
                    <span v-if="row.item.incoming_state === 'incoming'">{{ fmtDate(row.item.incoming_date) }}</span>
                    <b-badge v-else-if="row.item.incoming_state === 'stock'" variant="light-success">{{ $t('delivery.states.inStock') }}</b-badge>
                    <template v-else-if="row.item.incoming_state === 'unconfirmed'">
                      <b-badge variant="light-warning">{{ $t('delivery.states.unconfirmed') }}</b-badge>
                      <small v-if="row.item.incoming_lb_no" class="text-muted d-block">{{ row.item.incoming_lb_no }}</small>
                    </template>
                    <template v-else-if="row.item.incoming_state === 'supplier_overdue'">
                      <b-badge variant="light-danger">{{ $t('delivery.states.supplierOverdue') }}</b-badge>
                      <small v-if="row.item.incoming_lb_no" class="text-muted d-block">{{ row.item.incoming_lb_no }}</small>
                    </template>
                    <b-badge v-else-if="row.item.incoming_state === 'needs_purchasing'" variant="light-danger">
                      {{ $t('delivery.states.notOrdered') }}
                    </b-badge>
                  </span>
                  <b-popover :target="incomingCellId('s2', row.item.order_no)" triggers="hover" placement="top"
                    boundary="viewport" custom-class="incoming-popover" :title="$t('delivery.popover.title')" @show="loadIncomingPopover(row.item.order_no)">
                    <b-spinner v-if="incomingEntry(row.item.order_no).loading" small />
                    <span v-else-if="incomingEntry(row.item.order_no).error" class="text-danger">
                      {{ $t('delivery.popover.error') }}
                    </span>
                    <template v-else>
                      <div v-for="(line, idx) in incomingEntry(row.item.order_no).lines" :key="idx"
                        class="d-flex justify-content-between incoming-popover-line">
                        <span class="mr-1">{{ line.sku }} × {{ line.qty }}</span>
                        <span :class="line.variant ? `text-${line.variant}` : ''">{{ line.text }}</span>
                      </div>
                      <div v-if="!incomingEntry(row.item.order_no).lines.length" class="text-muted small">
                        {{ $t('delivery.popover.none') }}
                      </div>
                    </template>
                    <small class="text-muted d-block mt-50">
                      {{ $t('delivery.popover.matched') }}
                    </small>
                  </b-popover>
                  <div v-if="row.item.partial_delivery" class="mt-25">
                    <b-badge v-b-tooltip.hover.top="partialLabel(row.item)" variant="light-primary">{{ $t('delivery.states.partialDelivery') }}</b-badge>
                  </div>
                </template>
              </template>
              <template #cell(suggested)="row">
                <template v-if="row.item.suggested_date">
                  <span class="text-nowrap">{{ fmtDate(row.item.suggested_date) }}</span>
                  <small class="text-muted d-block">
                    {{ row.item.suggestion_reason === 'stock' ? $t('delivery.s2.fromStock') : $t('delivery.s2.afterIncoming') }}
                  </small>
                  <b-button size="sm" variant="outline-primary" class="mt-25"
                    :disabled="applyingOrderNo === row.item.order_no" @click.stop="applySuggestion(row.item)">
                    <b-spinner v-if="applyingOrderNo === row.item.order_no" small />
                    <span v-else>{{ $t('delivery.common.apply') }}</span>
                  </b-button>
                </template>
                <template v-else-if="row.item.suggestion_reason === 'unconfirmed'">
                  <b-badge variant="light-warning"
                    :title="$t('delivery.tips.orderedUnconfirmed')">
                    {{ $t('delivery.states.orderedAwaiting') }}
                  </b-badge>
                  <small v-if="row.item.suggestion_lb_no" class="text-muted d-block">{{ row.item.suggestion_lb_no }}</small>
                </template>
                <template v-else-if="row.item.suggestion_reason === 'supplier_overdue'">
                  <b-badge variant="light-danger"
                    :title="$t('delivery.tips.supplierOverdue')">
                    {{ $t('delivery.states.supplierOverdue') }}
                  </b-badge>
                  <small v-if="row.item.suggestion_lb_no" class="text-muted d-block">{{ row.item.suggestion_lb_no }}</small>
                </template>
                <b-badge v-else-if="row.item.suggestion_reason === 'needs_purchasing'" variant="light-danger"
                  :title="$t('delivery.tips.needsPurchasing')">
                  {{ $t('delivery.states.needsPurchasing') }}
                </b-badge>
                <span v-else class="text-muted">—</span>
                <!-- 24h auto-apply status (stock/incoming suggestions only —
                     unconfirmed/supplier_overdue/needs_purchasing rows never
                     carry an auto_status). fillna may send 0 instead of null,
                     so only the three known strings render anything. -->
                <div v-if="row.item.auto_status === 'pending'" class="mt-25">
                  <b-badge variant="light-info">
                    {{ $t(row.item.auto_apply_enabled ? 'delivery.auto.applies' : 'delivery.auto.wouldApply', { date: dateTimeFmt(row.item.auto_apply_at) }) }}
                  </b-badge>
                  <b-button size="sm" variant="outline-danger" class="ml-25 py-0 px-50"
                    @click.stop="openRejectModal(row.item.order_no)">
                    {{ $t('delivery.common.reject') }}
                  </b-button>
                </div>
                <b-badge v-else-if="row.item.auto_status === 'skipped'" variant="light-warning" class="mt-25 d-inline-block">
                  {{ $t('delivery.auto.skippedBadge', { reason: autoSkipLabel(row.item.auto_skip_reason) }) }}
                </b-badge>
                <div v-else-if="row.item.auto_status === 'rejected'" class="mt-25">
                  <b-badge variant="light-secondary" :title="rejectedTitle(row.item)">
                    {{ $t('delivery.auto.rejectedBadge', { reason: rejectedReasonLabel(row.item.auto_rejected_reason) }) }}
                  </b-badge>
                  <b-button variant="link" size="sm" class="p-0 ml-25 align-baseline"
                    @click.stop="unrejectSuggestion(row.item.order_no)">
                    {{ $t('delivery.common.undo') }}
                  </b-button>
                </div>
              </template>
              <template #cell(notes)="row">
                <span :title="row.item.notes || ''">{{ row.value }}</span>
              </template>
            </b-table>
            <pagination-bar :table="s2" @change="v => pageChange('s2', v)" />
          </b-card-body>
        </b-card>

        <!-- Auto-apply: skipped & rejected review card. Hidden by default;
             toggled by the "Review skipped & rejected" link above. Row click
             opens the same order detail modal as S1/S2. -->
        <b-card v-if="showAutoQueue" ref="autoQueueCard">
          <b-card-header>
            <h4 class="mb-0">
              <feather-icon icon="EyeIcon" size="20" class="mr-50" />
              {{ $t('delivery.auto.cardTitle') }}
            </h4>
            <p class="mb-0 text-muted">{{ $t('delivery.auto.cardDesc') }}</p>
          </b-card-header>
          <b-card-body class="card-body-table">
            <b-overlay :show="autoQueue.loading" spinner-variant="primary" rounded="sm">
              <b-table small striped hover responsive class="position-relative clickable-rows"
                :items="autoQueue.items" :fields="autoQueueFields" show-empty :empty-text="$t('delivery.auto.empty')"
                @row-clicked="item => openDetail('order', item)">
                <template #cell(order_no)="row">
                  <span class="copy-no" :title="$t('delivery.common.clickToCopy')" @click.stop="copy(row.item.order_no)">
                    {{ row.item.order_no }} <feather-icon icon="CopyIcon" size="12" />
                  </span>
                </template>
                <template #cell(status)="row">
                  <b-badge v-if="row.item.status === 'skipped'" variant="light-warning">
                    {{ $t('delivery.auto.skippedShort', { reason: autoSkipLabel(row.item.skip_reason) }) }}
                  </b-badge>
                  <b-badge v-else variant="light-secondary">
                    {{ $t('delivery.auto.rejectedBadge', { reason: rejectedReasonLabel(row.item.rejected_reason, row.item.rejected_reason_label) }) }}
                  </b-badge>
                </template>
                <template #cell(actions)="row">
                  <b-button v-if="row.item.status === 'rejected'" variant="link" size="sm" class="p-0"
                    @click.stop="unrejectSuggestion(row.item.order_no)">
                    {{ $t('delivery.common.undo') }}
                  </b-button>
                </template>
              </b-table>
            </b-overlay>
          </b-card-body>
        </b-card>
      </b-tab>

      <!-- ===================== STATISTICS (tool usage) ===================== -->
      <b-tab :title="$t('delivery.tabs.statistics')">
        <b-card class="mb-2">
          <b-card-header>
            <h4 class="mb-0">
              <feather-icon icon="BarChart2Icon" size="20" class="mr-50" />
              {{ $t('deliveryModal.stats.usageTitle') }}
            </h4>
            <p class="mb-0 text-muted">
              {{ $t('deliveryModal.stats.usageDesc') }}
            </p>
          </b-card-header>
          <b-card-body>
            <div class="d-flex flex-wrap align-items-center">
              <label for="dd-stats-weeks" class="mb-0 mr-50">{{ $t('deliveryModal.stats.window') }}</label>
              <v-select id="dd-stats-weeks" v-model="statsWeeks" label="text" :options="statsWeeksOptions"
                :reduce="o => o.value" :clearable="false" :searchable="false" class="mr-1 stats-weeks-select" />
              <b-button variant="outline-primary" :disabled="stats.loadingWeek || stats.loadingUser"
                @click="refreshStats">
                <feather-icon icon="RefreshCwIcon" size="14" class="mr-50" />
                {{ $t('delivery.common.refresh') }}
              </b-button>
              <small class="text-muted ml-auto pl-1">
                {{ $t('deliveryModal.stats.since', { date: stats.meta.since ? fmtDate(stats.meta.since) : '—' }) }}
              </small>
            </div>
          </b-card-body>
        </b-card>

        <b-row class="stats-overview-row mb-1">
          <b-col md="4" class="mb-1">
            <div class="modern-stat-card stat-card-static animate-fade-in">
              <div class="stat-icon-wrapper gradient-primary">
                <feather-icon icon="ToolIcon" size="28" />
              </div>
              <div class="stat-content">
                <div class="stat-header">
                  <h5 class="stat-title">
                    {{ $t('deliveryModal.stats.viaToolTitle') }}
                  </h5>
                </div>
                <div class="stat-value-wrapper">
                  <h2 class="stat-main-value">
                    {{ statsKpi.tool + statsKpi.toolAuto }}
                  </h2>
                  <div class="stat-hint">
                    <span class="stat-hint-who">{{ $t('deliveryModal.stats.lastWeeks', { n: statsWeeks }) }}</span> — {{ $t('deliveryModal.stats.viaToolHint') }}
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col md="4" class="mb-1">
            <div class="modern-stat-card stat-card-static animate-fade-in">
              <div class="stat-icon-wrapper gradient-warning">
                <feather-icon icon="ExternalLinkIcon" size="28" />
              </div>
              <div class="stat-content">
                <div class="stat-header">
                  <h5 class="stat-title">
                    {{ $t('deliveryModal.stats.directTitle') }}
                  </h5>
                </div>
                <div class="stat-value-wrapper">
                  <h2 class="stat-main-value">
                    {{ statsKpi.jtlDirect }}
                  </h2>
                  <div class="stat-hint">
                    <span class="stat-hint-who">{{ $t('deliveryModal.stats.lastWeeks', { n: statsWeeks }) }}</span> — {{ $t('deliveryModal.stats.directHint') }}
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col md="4" class="mb-1">
            <div class="modern-stat-card stat-card-static animate-fade-in">
              <div class="stat-icon-wrapper gradient-info">
                <feather-icon icon="PieChartIcon" size="28" />
              </div>
              <div class="stat-content">
                <div class="stat-header">
                  <h5 class="stat-title">
                    {{ $t('deliveryModal.stats.shareTitle') }}
                  </h5>
                </div>
                <div class="stat-value-wrapper">
                  <h2 class="stat-main-value">
                    {{ statsKpi.sharePct === null ? '—' : `${statsKpi.sharePct.toFixed(1)} %` }}
                  </h2>
                  <div class="stat-hint">
                    <span class="stat-hint-who">{{ $t('deliveryModal.stats.overall') }}</span> — {{ $t('deliveryModal.stats.shareHint') }}
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-overlay :show="stats.loadingWeek" spinner-variant="primary" rounded="sm">
          <b-card>
            <b-card-header>
              <h4 class="mb-0">
                <feather-icon icon="TrendingUpIcon" size="20" class="mr-50" />
                {{ $t('deliveryModal.stats.byWeekTitle') }}
              </h4>
              <p class="mb-0 text-muted">{{ $t('deliveryModal.stats.byWeekDesc') }}</p>
            </b-card-header>
            <b-card-body>
              <ECharts :theme="echartsTheme" :options="usageByWeekChart" style="width: 100%; height: 320px;"
                autoresize />
            </b-card-body>
          </b-card>
        </b-overlay>

        <b-overlay :show="stats.loadingUser" spinner-variant="primary" rounded="sm">
          <b-card>
            <b-card-header>
              <h4 class="mb-0">
                <feather-icon icon="UsersIcon" size="20" class="mr-50" />
                {{ $t('deliveryModal.stats.byUserTitle') }}
              </h4>
              <p class="mb-0 text-muted">
                {{ $t('deliveryModal.stats.byUserDesc') }}
              </p>
            </b-card-header>
            <b-card-body class="card-body-table">
              <b-table striped hover small responsive class="position-relative" :items="stats.byUser"
                :fields="statsUserFields" sort-by="total" :sort-desc="true" :tbody-tr-class="statsUserRowClass"
                show-empty :empty-text="$t('deliveryModal.stats.noData')">
                <template #cell(name)="row">
                  <span :class="{ 'text-muted': row.item.is_system }">{{ row.item.name }}</span>
                </template>
                <template #cell(tool_share_pct)="row">
                  <b-badge v-if="row.item.total > 0" :variant="statsShareVariant(row.item.tool_share_pct)">
                    {{ Number(row.item.tool_share_pct).toFixed(1) }} %
                  </b-badge>
                  <span v-else class="text-muted">—</span>
                </template>
                <template #cell(other_actions)="row">
                  <span v-if="row.item.other_actions > 0" v-b-tooltip.hover.top="otherActionsTooltip(row.item)">
                    {{ row.item.other_actions }}
                  </span>
                  <span v-else class="text-muted">0</span>
                </template>
                <template #cell(last_tool_use)="row">
                  <span v-if="row.item.last_tool_use">{{ dateTimeFmt(row.item.last_tool_use) }}</span>
                  <span v-else class="text-danger">{{ $t('delivery.common.never') }}</span>
                </template>
                <template #cell(last_jtl_change)="row">
                  <span v-if="row.item.last_jtl_change">{{ dateTimeFmt(row.item.last_jtl_change) }}</span>
                  <span v-else class="text-muted">—</span>
                </template>
              </b-table>
            </b-card-body>
          </b-card>
        </b-overlay>
      </b-tab>
    </b-tabs>

    <!-- ===================== DETAIL MODAL ===================== -->
    <b-modal ref="detailModal" size="xl" :title="detailTitle" hide-footer @shown="onDetailShown" @hidden="resetDetail">
      <b-overlay :show="detail.loading" spinner-variant="primary" rounded="sm">

        <!-- ---------- Customer order ---------- -->
        <template v-if="detail.type === 'order'">
          <b-card class="border mb-1">
            <b-row>
              <b-col md="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.customer') }}</div>
                <div class="detail-value">{{ detail.header.customer || '—' }}</div>
                <div v-if="detail.header.contact_name && detail.header.contact_name !== detail.header.customer"
                  class="text-muted small">
                  {{ detail.header.contact_name }}
                </div>
              </b-col>
              <b-col md="3" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.source') }}</div>
                <b-badge :variant="detail.header.source === 'Manuell' ? 'light-warning' : 'light-info'">
                  {{ detail.header.source || '—' }}
                </b-badge>
                <b-badge v-if="detail.header.on_hold" variant="light-warning" class="ml-25"
                  :title="$t('delivery.tips.heldBack')">
                  {{ detail.header.hold_reason ? $t('deliveryModal.detail.holdBadge', { reason: detail.header.hold_reason }) : $t('delivery.states.onHold') }}
                </b-badge>
              </b-col>
              <b-col md="3" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.owner') }}</div>
                <div class="detail-value">{{ detail.header.owner || '—' }}</div>
              </b-col>

              <b-col md="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.address') }}</div>
                <div class="detail-value">
                  <div v-if="detail.header.street">{{ detail.header.street }}</div>
                  <div>{{ [detail.header.postal_code, detail.header.city].filter(Boolean).join(' ') }}</div>
                  <div v-if="detail.header.country">{{ detail.header.country }}</div>
                  <span v-if="!detail.header.street && !detail.header.city">—</span>
                </div>
              </b-col>
              <b-col md="3" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.email') }}</div>
                <a v-if="detail.header.customer_email" :href="`mailto:${detail.header.customer_email}`">
                  {{ detail.header.customer_email }}
                </a>
                <span v-else>—</span>
              </b-col>
              <b-col md="3" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.phone') }}</div>
                <div class="detail-value">{{ detail.header.customer_tel || '—' }}</div>
              </b-col>

              <b-col md="3" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.orderDate') }}</div>
                <div class="detail-value">{{ fmtDate(detail.header.order_date) || '—' }}</div>
              </b-col>
              <b-col md="3" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.promisedDelivery') }}</div>
                <div class="delivery-date-edit d-flex">
                  <flat-pickr v-model="editPromisedDate" class="form-control" :placeholder="$t('deliveryModal.detail.noDatePlaceholder')" />
                  <b-button variant="primary" :disabled="savingPromisedDate || !promisedDateChanged || !editReason"
                    @click="saveOrderPromisedDate('manual')">
                    <b-spinner v-if="savingPromisedDate" small />
                    <span v-else>{{ $t('delivery.common.save') }}</span>
                  </b-button>
                </div>
                <!-- Reason for the change (Lukas: a manual date change must always
                     say why, so we learn what needs correcting). Only shown while
                     the picker differs from the saved date; applying the tool's
                     own suggestion below needs no reason. -->
                <div v-if="promisedDateChanged" class="mt-50">
                  <v-select v-model="editReason" label="text" :options="dateChangeReasons" :reduce="o => o.value"
                    :placeholder="$t('deliveryModal.detail.reasonPlaceholder')" :clearable="false" class="mb-25 select-size-sm" />
                  <b-form-input v-model="editReasonNote" size="sm" maxlength="200" :placeholder="$t('deliveryModal.detail.notePlaceholder')" />
                  <small v-if="!editReason" class="text-danger d-block mt-25">
                    {{ $t('deliveryModal.detail.chooseReason') }}
                  </small>
                </div>
                <b-button-group class="mt-50">
                  <b-button v-for="n in quickDateOffsets" :key="n" size="sm" variant="outline-primary"
                    :disabled="savingPromisedDate || quickDate(n) < todayYmd()" :title="fmtDate(quickDate(n))"
                    @click="applyQuickDate(n)">
                    +{{ n }}
                  </b-button>
                </b-button-group>
                <small v-if="quickDateBase !== todayYmd()" class="text-muted d-block">
                  {{ $t('deliveryModal.detail.quickFromPayment', { date: fmtDate(quickDateBase) }) }}
                </small>
                <small v-if="suggestedPromisedDate && !originalPromisedDate" class="text-muted">
                  {{ $t('deliveryModal.detail.suggestedLine', { date: fmtDate(suggestedPromisedDate), basis: suggestionBasis }) }}
                  <b-button size="sm" variant="outline-success" class="ml-25 py-0" :disabled="savingPromisedDate"
                    @click="applyModalSuggestion">
                    {{ $t('delivery.common.apply') }}
                  </b-button>
                </small>
                <small v-else-if="!originalPromisedDate && modalSuggestion.reason === 'unconfirmed'"
                  class="text-muted d-block">
                  {{ $t('deliveryModal.detail.awaitingConfirmation', { lb: modalSuggestion.lbNo ? ` (${modalSuggestion.lbNo})` : '' }) }}
                </small>
                <small v-else-if="!originalPromisedDate && modalSuggestion.reason === 'supplier_overdue'"
                  class="text-muted d-block">
                  {{ $t('deliveryModal.detail.supplierMissed', { lb: modalSuggestion.lbNo ? ` (${modalSuggestion.lbNo})` : '' }) }}
                </small>
                <small v-else-if="!originalPromisedDate && modalSuggestion.reason === 'needs_purchasing'"
                  class="text-muted d-block">
                  {{ $t('deliveryModal.detail.needsPurchasing') }}
                </small>
                <b-alert v-if="promisedLate || supplierMissed" variant="warning" show class="mt-50 mb-0 py-25 px-1">
                  <small v-if="promisedLate" class="d-block">
                    {{ $t('deliveryModal.detail.warnLate', { incoming: fmtDate(maxIncomingDate), promised: fmtDate(originalPromisedDate) }) }}
                  </small>
                  <small v-if="supplierMissed" class="d-block">
                    {{ $t('deliveryModal.detail.warnOverdue') }}
                  </small>
                  <b-button v-if="modalSuggestion.date && modalSuggestion.date !== originalPromisedDate" size="sm"
                    variant="warning" class="mt-25" :disabled="savingPromisedDate" @click="applyModalSuggestion">
                    <b-spinner v-if="savingPromisedDate" small />
                    <span v-else>{{ $t('deliveryModal.detail.applyNewDate', { date: fmtDate(modalSuggestion.date) }) }}</span>
                  </b-button>
                </b-alert>
                <!-- 24h auto-apply status: the S2 row object isn't available here,
                     so this looks up autoQueueByOrder (built from the already-loaded
                     s2.items) by order number. Limitation: only resolves when this
                     order is on the currently loaded S2 page/filters — opened via a
                     direct link or from S1/search it may show nothing even though
                     it does have an auto-apply status. -->
                <small v-if="autoQueueByOrder[detail.orderNo] && autoQueueByOrder[detail.orderNo].auto_status"
                  class="d-block mt-50">
                  <template v-if="autoQueueByOrder[detail.orderNo].auto_status === 'pending'">
                    {{ $t('delivery.auto.modalPending', { date: dateTimeFmt(autoQueueByOrder[detail.orderNo].auto_apply_at) }) }}
                    <b-button variant="link" size="sm" class="p-0 ml-25 align-baseline"
                      @click="openRejectModal(detail.orderNo)">
                      {{ $t('delivery.common.reject') }}
                    </b-button>
                  </template>
                  <template v-else-if="autoQueueByOrder[detail.orderNo].auto_status === 'skipped'">
                    {{ $t('delivery.auto.modalSkipped', { reason: autoSkipLabel(autoQueueByOrder[detail.orderNo].auto_skip_reason) }) }}
                  </template>
                  <template v-else-if="autoQueueByOrder[detail.orderNo].auto_status === 'rejected'">
                    {{ $t('delivery.auto.modalRejected', { reason: rejectedReasonLabel(autoQueueByOrder[detail.orderNo].auto_rejected_reason) }) }}
                    <b-button variant="link" size="sm" class="p-0 ml-25 align-baseline"
                      @click="unrejectSuggestion(detail.orderNo)">
                      {{ $t('delivery.common.undo') }}
                    </b-button>
                  </template>
                </small>
              </b-col>
              <b-col md="3" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.payment') }}</div>
                <div class="detail-value">{{ detail.header.payment_method || '—' }}</div>
                <small v-if="detail.header.paid_date" class="text-muted">
                  {{ $t('deliveryModal.detail.paidOn', { date: fmtDate(detail.header.paid_date) }) }}
                </small>
              </b-col>
              <b-col md="3" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.shipping') }}</div>
                <div class="detail-value">{{ detail.header.shipping_method || '—' }}</div>
              </b-col>

              <b-col md="3" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.externalOrderNo') }}</div>
                <div class="detail-value">{{ detail.header.external_order_no || '—' }}</div>
              </b-col>
              <b-col md="3" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.priority') }}</div>
                <!-- Saving reloads the modal (cHinweis gains a line), which would drop
                     unsaved note/date edits — so block it until those are saved. -->
                <v-select v-model="editPriority" label="text" :options="modalPriorityOptions" :reduce="o => o.value"
                  :selectable="o => !o.disabled" :clearable="false"
                  :disabled="savingPriority || notesChanged || promisedDateChanged" @input="saveOrderPriority" />
                <small v-if="notesChanged || promisedDateChanged" class="text-muted d-block mt-25">
                  {{ $t('deliveryModal.detail.saveOthersFirst') }}
                </small>
              </b-col>
              <b-col md="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.orderTotal') }}</div>
                <div class="detail-value font-weight-bold">{{ euro(detail.header.order_total) }}</div>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.customerNote') }}</div>
                <b-form-textarea v-model="editNote" rows="4" max-rows="12" :placeholder="$t('deliveryModal.detail.noCustomerNote')" />
              </b-col>
              <b-col md="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.internalComment') }}</div>
                <b-form-textarea v-model="editComment" rows="4" max-rows="12" :placeholder="$t('deliveryModal.detail.noInternalComment')"
                  :disabled="addingComment" />
                <div class="d-flex align-items-center mt-50">
                  <b-form-input v-model="newCommentLine" size="sm" :placeholder="$t('deliveryModal.detail.addCommentPlaceholder')" />
                  <b-button size="sm" variant="primary" class="ml-50" :disabled="addCommentDisabled" @click="addComment">
                    <b-spinner v-if="addingComment" small />
                    <span v-else>{{ $t('delivery.common.add') }}</span>
                  </b-button>
                </div>
                <small v-if="commentChanged" class="text-muted">{{ $t('deliveryModal.detail.saveCommentFirst') }}</small>
              </b-col>
              <b-col md="12" class="d-flex align-items-center">
                <b-button variant="primary" :disabled="savingNotes || !notesChanged" @click="saveOrderNotes">
                  <b-spinner v-if="savingNotes" small />
                  <span v-else>{{ $t('deliveryModal.detail.saveNotes') }}</span>
                </b-button>
              </b-col>
            </b-row>
          </b-card>

          <b-alert v-if="detail.partial || partialDelivery" variant="info" show class="mb-1 py-50 px-1">
            <small>
              <feather-icon icon="PackageIcon" size="14" class="mr-25" />
              <template v-if="detail.partial">
                <strong>{{ $t('deliveryModal.detail.partialPossible') }}</strong> — {{ partialLabel(detail.partial) }}.
              </template>
              <template v-else>
                {{ $t('deliveryModal.detail.partialStock', { available: partialDelivery.available, total: partialDelivery.total, date: partialDelivery.remainderDate ? fmtDate(partialDelivery.remainderDate) : $t('delivery.common.tbd') }) }}
              </template>
            </small>
            <b-button size="sm" variant="info" class="ml-50" :disabled="appendingNote || !partialDelivery"
              @click="notePartialDelivery">
              <b-spinner v-if="appendingNote" small />
              <span v-else><feather-icon icon="Edit3Icon" size="12" class="mr-25" />{{ $t('deliveryModal.detail.noteInComment') }}</span>
            </b-button>
          </b-alert>

          <h6 class="mb-50">
            <feather-icon icon="ListIcon" size="16" class="mr-50" />{{ $t('deliveryModal.detail.positionsCount', { n: detail.positions.length }) }}
          </h6>
          <b-table small responsive class="mb-2" :items="detail.positions" :fields="orderPosFields" show-empty
            :empty-text="$t('deliveryModal.detail.noPositions')">
            <template #cell(delivery_time)="row">
              <div>{{ deliveryTimeValue(row.item) }}</div>
              <small v-if="deliveryTimeHint(row.item)" v-b-tooltip.hover="deliveryTimeTooltip(row.item)"
                :class="row.item.delivery_time_state === 'maybe_changed' ? 'text-warning' : 'text-muted'">
                {{ deliveryTimeHint(row.item) }}
              </small>
            </template>
            <template #cell(availability)="row">
              <template v-if="isStockPosition(row.item)">
                <b-badge v-if="availabilityState(row.item) === 'available'" variant="light-success">
                  {{ $t('deliveryModal.detail.availableQty', { n: Number(row.item.available_qty) }) }}
                </b-badge>
                <b-badge v-else-if="availabilityState(row.item) === 'reserved'" variant="light-info">
                  {{ $t('deliveryModal.detail.reserved') }}
                </b-badge>
                <template v-else>
                  <b-badge variant="light-danger">{{ $t('deliveryModal.detail.outOfStock') }}</b-badge>
                  <small v-if="incomingForSku(row.item.item_sku)" class="text-muted ml-50">
                    · {{ incomingForSku(row.item.item_sku) }}
                  </small>
                </template>
              </template>
              <span v-else class="text-muted">—</span>
            </template>
          </b-table>

          <h6 class="mb-50">
            <feather-icon icon="TruckIcon" size="16" class="mr-50" />{{ $t('deliveryModal.detail.linkedLbs', { n: detail.linkedLbs.length }) }}
          </h6>
          <b-table small responsive :items="detail.linkedLbs" :fields="linkedLbFields" show-empty
            :tbody-tr-class="lbRowClass" :empty-text="$t('deliveryModal.detail.noLinkedLbs')">
            <template #cell(lb_no)="row">
              <div>{{ row.item.lb_no }}</div>
              <small v-if="row.item.order_date" class="text-muted text-nowrap">
                {{ $t('deliveryModal.detail.orderedOn', { date: fmtDate(row.item.order_date) }) }}
              </small>
            </template>
            <template #cell(item)="row">
              <div><strong>{{ row.item.item_sku || '—' }}</strong></div>
              <small class="text-muted">{{ row.item.item_name }}</small>
            </template>
            <template #cell(open_qty)="row">{{ Number(row.item.open_qty) }}</template>
            <template #cell(status)="row">
              <b-badge variant="light-secondary">{{ row.item.status }}</b-badge>
            </template>
            <template #cell(delivery_date)="row">
              <span v-if="fmtDate(row.item.delivery_date)">{{ fmtDate(row.item.delivery_date) }}</span>
              <b-badge v-else variant="light-warning">{{ $t('delivery.common.tbd') }}</b-badge>
            </template>
            <template #cell(match_type)="row">
              <b-badge :variant="row.item.match_type === 'article' ? 'light-info' : 'light-primary'">
                {{ row.item.match_type === 'article' ? $t('deliveryModal.detail.matchArticle') : $t('deliveryModal.detail.matchOrderRef') }}
              </b-badge>
            </template>
          </b-table>
        </template>

        <!-- ---------- Supplier LB ---------- -->
        <template v-else>
          <b-card class="border mb-1">
            <b-row>
              <b-col md="4" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.supplier') }}</div>
                <div class="detail-value">{{ detail.header.supplier || '—' }}</div>
              </b-col>
              <b-col md="4" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.buyer') }}</div>
                <div class="detail-value">{{ detail.header.buyer || '—' }}</div>
              </b-col>
              <b-col md="4" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.status') }}</div>
                <b-badge variant="light-secondary">{{ detail.header.status || '—' }}</b-badge>
              </b-col>
              <b-col md="4" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.lbOrderDate') }}</div>
                <div class="detail-value mb-1">{{ fmtDate(detail.header.order_date) || '—' }}</div>
                <div class="detail-label">{{ $t('deliveryModal.detail.deliveryDate') }}</div>
                <div class="delivery-date-edit d-flex">
                  <flat-pickr v-model="editDeliveryDate" class="form-control" :placeholder="$t('deliveryModal.detail.noDatePlaceholder')" />
                  <b-button variant="primary" :disabled="savingDate || !lbDateChanged" @click="saveLbDeliveryDate">
                    <b-spinner v-if="savingDate" small />
                    <span v-else>{{ $t('delivery.common.save') }}</span>
                  </b-button>
                </div>
              </b-col>
              <b-col md="4" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.lbOrderTotal') }}</div>
                <div class="detail-value font-weight-bold">{{ euro(detail.header.order_total) }}</div>
              </b-col>
              <b-col md="4" sm="6" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.reference') }}</div>
                <div class="detail-value">{{ detail.header.sales_order_no || '—' }}</div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="mb-1">
                <div class="detail-label">{{ $t('deliveryModal.detail.internalComment') }}</div>
                <b-form-textarea v-model="editComment" rows="4" max-rows="12" :placeholder="$t('deliveryModal.detail.noInternalComment')"
                  :disabled="addingComment" />
                <div class="d-flex align-items-center mt-50">
                  <b-form-input v-model="newCommentLine" size="sm" :placeholder="$t('deliveryModal.detail.addCommentPlaceholder')" />
                  <b-button size="sm" variant="primary" class="ml-50" :disabled="addCommentDisabled" @click="addComment">
                    <b-spinner v-if="addingComment" small />
                    <span v-else>{{ $t('delivery.common.add') }}</span>
                  </b-button>
                </div>
                <small v-if="commentChanged" class="text-muted">{{ $t('deliveryModal.detail.saveCommentFirst') }}</small>
              </b-col>
              <b-col md="12" class="d-flex align-items-center">
                <b-button variant="primary" :disabled="savingNotes || !commentChanged" @click="saveLbNotes">
                  <b-spinner v-if="savingNotes" small />
                  <span v-else>{{ $t('deliveryModal.detail.saveNotes') }}</span>
                </b-button>
              </b-col>
            </b-row>
          </b-card>

          <h6 class="mb-50">
            <feather-icon icon="ListIcon" size="16" class="mr-50" />{{ $t('deliveryModal.detail.positionsCount', { n: detail.positions.length }) }}
          </h6>
          <b-table small responsive :items="detail.positions" :fields="posFields" show-empty
            :empty-text="$t('deliveryModal.detail.noPositions')" />
        </template>

      </b-overlay>
    </b-modal>

    <!-- ===================== REJECT SUGGESTION MODAL ===================== -->
    <!-- Shared by the S2 row Reject button, the review card (via the order
         modal it opens), and the order-modal pending line. -->
    <b-modal id="reject-suggestion-modal" ref="rejectModal" size="sm"
      :title="$t('deliveryModal.rejectModal.title', { no: rejectTarget.orderNo })" :ok-disabled="!rejectTarget.reason || rejecting"
      :ok-title="rejecting ? $t('deliveryModal.rejectModal.rejecting') : $t('delivery.common.reject')" :cancel-title="$t('delivery.common.cancel')" ok-variant="danger" cancel-variant="outline-secondary"
      @ok="submitReject" @hidden="rejectTarget = { orderNo: '', reason: '', note: '' }">
      <b-form-group :label="$t('deliveryModal.rejectModal.reason')" label-for="dd-reject-reason">
        <v-select id="dd-reject-reason" v-model="rejectTarget.reason" label="text" :options="dateChangeReasons"
          :reduce="o => o.value" :placeholder="$t('deliveryModal.rejectModal.reasonPlaceholder')" :clearable="false" class="select-size-sm" />
      </b-form-group>
      <b-form-group :label="$t('deliveryModal.rejectModal.note')" label-for="dd-reject-note">
        <b-form-input id="dd-reject-note" v-model="rejectTarget.note" size="sm" maxlength="200" />
      </b-form-group>
    </b-modal>
  </section>
</template>

<script>
// ===================== URL DEEP-LINK CONTRACT (WP-2) =====================
// Backend-generated links (Slack delivery-date reminders) open this page
// pre-filtered:
//   /delivery-date-dashboard?tab=support|purchasing&owner=<kBenutzer>&buyer=<kBenutzer>&status=<comma list>
// All params are optional; any subset may be present.
//   - tab: 'support' -> activeTab 1, 'purchasing' -> activeTab 0. Any other
//     value (e.g. a hypothetical 'statistics') is ignored — only 0/1 are
//     reachable via this contract.
//   - owner: applies on the support tab only. Resolved against supportOwners
//     (from the order-owners endpoint) into the {title, value} shape v-select
//     needs; falls back to a synthetic {title: 'Owner <id>', value: id} when
//     the id isn't in the loaded list, so the server-side filter still applies.
//   - buyer: same idea, on the purchasing tab only, resolved against
//     purchasingOwners (lb-buyers). Both owner and buyer ultimately write to
//     selectedOwner — the same field is reused per tab, see the ownerOptions
//     computed below (purchasingOwners on tab 0, supportOwners on tab 1).
//   - status: comma list mapped onto SUPPORT_STATUS_OPTIONS
//     (no_date/overdue/due_soon/definitely_late/later) when the resolved tab
//     is support, or PURCH_STATUS_OPTIONS (overdue/due_soon/blocking) when
//     purchasing. Values with no matching option today (e.g. 'unconfirmed' —
//     there is no such filter chip on the Purchasing tab) are silently
//     dropped, per-value, rather than failing the whole list.
// Applied in created(): tab + status are set right after loadFilters() (so
// they override the restored/persisted values) and before the initial fetch.
// owner/buyer need ownerOptions, which load asynchronously (loadOwners()), so
// they're applied once that resolves, still before refreshAll() issues the
// first request. When any of the four params is present we also clear the
// search box and "only mine" so the linked view shows exactly the intended
// set. Nothing here changes how state is persisted — the normal filterState
// watcher saves the URL-driven values like any user-made change. Once
// applied, the query string is stripped via router.replace (without a
// reload) so a later plain reload falls back to the persisted filters.
import {
  BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
  BInputGroup, BInputGroupPrepend, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BBadge, BTabs, BTab,
  BModal, BOverlay, BButton, BButtonGroup, BSpinner, BAlert, BPopover, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import * as XLSX from 'xlsx'
import axios from 'axios'
import ECharts from 'vue-echarts'
import echartsTheme from '@/mixins/echartsTheme'
import BackorderList from './components/BackorderList.vue'

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

const API = process.env.VUE_APP_ROOT_API
// Shared write endpoints only log a usage action when they see this marker.
const DASHBOARD_SOURCE = 'delivery_dashboard'

const dateFmt = value => {
  if (!value) return ''
  const d = new Date(value)
  // de-DE with 2-digit day/month renders zero-padded dd.mm.yyyy, matching the
  // rest of the app. Used by every table column and the detail modal.
  return Number.isNaN(d.getTime())
    ? ''
    : d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
}
// Date + time (dd.mm.yyyy HH:mm) for the Statistics tab's "last used" columns —
// dateFmt alone would drop the time-of-day that matters for "when did they last
// touch this".
const dateTimeFmt = value => {
  if (!value) return ''
  const d = new Date(value)
  return Number.isNaN(d.getTime())
    ? ''
    : d.toLocaleString('de-DE', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
    })
}
const euroFmt = v => {
  if (v === null || v === undefined || v === '') return '—'
  const n = Number(v)
  return Number.isNaN(n) ? '—' : n.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
}
// Truncated preview for the notes column; the untruncated value is still
// available via the cell's title attribute (hover tooltip).
const notesFmt = v => (v && v.length > 50 ? `${v.substring(0, 50)}...` : v || '')

// Age-in-days tiers for the S1/S2 "Age (days)" column highlight (very old orders,
// e.g. from April, must stand out at a glance).
const AGE_WARN_DAYS = 28
const AGE_CRITICAL_DAYS = 56

// One-click "promised date = base + N days" offsets for the order-modal quick
// buttons (base = today, or the payment date for paid Vorkasse), mirroring the
// JTL one-click "Lieferdatum +N Tage" workflow.
const QUICK_DATE_OFFSETS = [3, 7, 10, 14, 21]
// JTL "Priorität ändern" range (tAuftrag.nLieferPrioritaet); legacy 6–9 only display.
const PRIORITY_VALUES = Array.from({ length: 11 }, (_, i) => i - 5)
const PRIORITY_TEXT_KEYS = { '-5': 'low', 0: 'normal', 5: 'high' }
// Country-group values are sent to the backend as-is; only their labels are translated.
const COUNTRY_GROUP_KEYS = { Germany: 'germany', 'EU (except Germany)': 'eu', 'Outside EU': 'nonEu' }
const COUNTRY_GROUPS = Object.keys(COUNTRY_GROUP_KEYS)

// Reasons for a manual promised-delivery-date change (Lukas: must always know
// why staff moved the date). Mirrors the backend's reason choices 1:1 — order
// matters (rendered as the select's option order). Applying the tool's own
// suggestion needs no reason (source: 'suggestion' on the API).
const DATE_CHANGE_REASON_CODES = [
  'initial_date', 'supplier_delay', 'customer_request', 'partial_delivery',
  'not_ordered_yet', 'stock_error', 'other',
]

// Local-date helpers for the suggestion computeds. Everything is compared and
// added as plain YYYY-MM-DD strings via the local calendar — no UTC parsing, so
// no off-by-one around midnight/timezones.
const ymd = d => {
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}
const todayYmd = () => ymd(new Date())
const addDaysYmd = (base, days) => {
  const [y, m, d] = base.split('-').map(Number)
  return ymd(new Date(y, m - 1, d + days))
}

// Small pagination component to avoid repeating the markup per table. Uses a
// render function (not a string template) because the app is built with the
// runtime-only Vue build, which has no template compiler. Mirrors the
// first/last-number + chevron styling used by the other dashboards.
const PaginationBar = {
  name: 'PaginationBar',
  components: { BPagination },
  props: { table: { type: Object, required: true } },
  render(h) {
    return h('div', { class: 'd-flex justify-content-between flex-wrap pt-0 pagination-wrapper' }, [
      h('div', [
        h(BPagination, {
          props: {
            value: this.table.currentPage,
            totalRows: this.table.totalRows,
            firstNumber: true,
            lastNumber: true,
            prevClass: 'prev-item',
            nextClass: 'next-item',
          },
          class: 'mb-0',
          on: { change: v => this.$emit('change', v) },
          scopedSlots: {
            'prev-text': () => h('feather-icon', { props: { icon: 'ChevronLeftIcon', size: '18' } }),
            'next-text': () => h('feather-icon', { props: { icon: 'ChevronRightIcon', size: '18' } }),
          },
        }),
      ]),
    ])
  },
}

// Column definitions live in the tableFields computed so labels follow the UI language.
const newTable = (sortBy, sortDesc = false) => ({
  items: [], totalRows: 0, currentPage: 1, sortBy, sortDesc,
})

// Canonical status-filter option sets, per tab. Kept as shared constants (not
// inline literals) so the KPI-card shortcuts and loadFilters migration can pick
// options by reference/value and v-select equality still matches.
// Values only: titles are translated in the statusOptions computed.
const SUPPORT_STATUS_OPTIONS = [
  { value: 'overdue' },
  { value: 'due_soon' },
  { value: 'no_date' },
  { value: 'definitely_late' },
  { value: 'later' },
  // Not a date bucket: narrows S1 and S2 to server-flagged orders (partial_only).
  { value: 'partial_delivery' },
]
const DEFAULT_SUPPORT_STATUSES = ['overdue', 'due_soon']
const PARTIAL_ACTION_KEYS = { ship_now: 'shipNow', offer: 'offer' }
const PURCH_STATUS_OPTIONS = [
  { value: 'overdue' },
  { value: 'due_soon' },
  { value: 'no_date' },
  { value: 'blocking' },
]
const DEFAULT_PURCH_STATUSES = ['overdue', 'due_soon', 'blocking']

// Window choices for the Statistics tab's weeks selector — also the allowed set
// used to sanitize a stored statsWeeks value in loadFilters.
const STATS_WEEKS_OPTIONS = [4, 8, 12, 26]

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BInputGroup,
    BInputGroupPrepend,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BBadge,
    BTabs,
    BTab,
    BModal,
    BOverlay,
    BButton,
    BButtonGroup,
    BSpinner,
    BAlert,
    BPopover,
    vSelect,
    flatPickr,
    PaginationBar,
    ECharts,
    BackorderList,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [echartsTheme],
  data() {
    return {
      activeTab: 0,
      searchValue: '',
      selectedOwner: '',
      // Support-tab-only filters (platform = order source, country group of the
      // delivery address). LBs have neither, so they show only when activeTab===1.
      selectedPlatform: '',
      selectedCountryGroup: [],
      selectedPriority: [],
      platformOptions: [],
      // Payment status filter (support tab only): paid / partial / unpaid.
      selectedPayment: '',
      // Status filter for the due-soon lists (S1 orders + E1 LBs): multi-select of
      // traffic-light buckets, any combination. Maps to the backend want_overdue /
      // want_due_soon / want_no_date / want_definitely_late flags (see listParams).
      // Default = the two actionable dated buckets (matches the old "Has date"
      // default).
      selectedStatuses: SUPPORT_STATUS_OPTIONS.filter(o => DEFAULT_SUPPORT_STATUSES.includes(o.value)),
      // Purchasing (E1) equivalent. Default includes "Blocks late order" so the
      // previously always-on blocking branch keeps surfacing by default — adding
      // the chip only makes that branch filterable, it doesn't change the default
      // result set.
      selectedStatusesPurch: PURCH_STATUS_OPTIONS.filter(o => DEFAULT_PURCH_STATUSES.includes(o.value)),
      onlyMine: false,
      // Transient: which KPI card triggered the pending tab switch, consumed by
      // onTabChange once the tab has actually switched. Never persisted.
      pendingCardApply: '',
      // No default window: never-closed old orders are exactly the forgotten
      // delays this dashboard exists to surface, so show everything unless
      // the user narrows it down.
      createdAfter: '',
      daysNoDate: 3,
      summary: {
        support_overdue: 0,
        purchasing_overdue: 0,
        backorder_danger: 0,
        backorder_warn: 0,
        backorder_supplier_stock: 0,
        backorder_lb_no: '',
        support_no_date: 0,
        lb_unconfirmed: 0,
        support_definitely_late: 0,
        support_overdue_unpaid: 0,
        support_no_date_unpaid: 0,
        support_definitely_late_unpaid: 0,
      },
      // Order number whose S2 suggestion is currently being applied (row spinner).
      applyingOrderNo: '',
      // 24h auto-apply of S2 suggestions (stock/incoming): status/counts from
      // auto-apply-status (support-tab info line above S2), plus the review
      // list of skipped/rejected rows (auto-apply-queue), fetched only when the
      // review card is toggled open.
      autoApply: {
        enabled: false, delayHours: 24, counts: { pending: 0, skipped: 0, rejected: 0 }, lastRunAt: '',
      },
      showAutoQueue: false,
      autoQueue: { items: [], loading: false },
      // Reject-suggestion modal target (shared by the S2 row button, the review
      // card's rejected rows aren't editable here — only Undo — and the order
      // modal's pending line).
      rejectTarget: { orderNo: '', reason: '', note: '' },
      rejecting: false,
      supportOwners: [],
      purchasingOwners: [],
      // Row-click detail modal (customer order or supplier LB).
      detail: {
        type: 'order', orderNo: '', loading: false, header: {}, positions: [], linkedLbs: [], partial: null,
      },
      // S1/S2 "Incoming" column hover popover: order_no -> { loading, error, lines }.
      // Lazy-loaded on first hover (loadIncomingPopover) via the same
      // order-positions/order-linked-lbs endpoints the detail modal uses, and kept
      // here (not on detail) so it survives independently of whichever order the
      // modal currently has open. Cleared in getList() so a refresh can't leave
      // stale positions behind. Uses $set — keys are added dynamically per order.
      incomingCache: {},
      // Inline editing of the supplier-LB delivery date inside the detail modal.
      // editDeliveryDate is bound to the picker; originalDeliveryDate is the value
      // last loaded/saved so the Save button only enables on an actual change.
      editDeliveryDate: '',
      originalDeliveryDate: '',
      savingDate: false,
      // Inline editing of the customer-order promised delivery date (S1/S2).
      // editPromisedDate is bound to the picker; originalPromisedDate is the value
      // last loaded/saved so the Save button only enables on an actual change.
      editPromisedDate: '',
      originalPromisedDate: '',
      savingPromisedDate: false,
      editPriority: null,
      savingPriority: false,
      // Quick "+N days" buttons (order modal only) — offsets exposed to the
      // template via data since module-level consts aren't reachable there.
      quickDateOffsets: QUICK_DATE_OFFSETS,
      // Reason for a manual promised-date change (order modal only) — required
      // whenever the picker differs from the saved date via manual/quick source;
      // not required when applying the tool's own suggestion.
      editReason: '',
      editReasonNote: '',
      // Inline editing of the customer note (cAnmerkung) and internal comment
      // (cHinweis). original* hold the last loaded/saved values so Save only
      // enables when either field actually changed.
      editNote: '',
      editComment: '',
      originalNote: '',
      originalComment: '',
      savingNotes: false,
      // Appending the partial-delivery hint line to the internal comment.
      appendingNote: false,
      // "Add comment" line, prepended server-side to the internal comment.
      newCommentLine: '',
      addingComment: false,
      e1: newTable('delivery_date'),
      e2: newTable('days_since_ordered', true),
      e3: newTable('age_days', true),
      // E4 — customer orders waiting for purchasing (S2's needs_purchasing /
      // supplier_overdue rows, surfaced on the Purchasing tab so buyers act on
      // them). Hits the same endpoint as S2 (orders-no-date) with
      // purchasing_only=1 — see listParams('e4') / endpoints below.
      e4: newTable('priority_score', true),
      s1: newTable('delivery_date'),
      s2: newTable('priority_score', true),
      // ===================== STATISTICS (tool usage) =====================
      // Weeks window shared by both usage requests. Persisted via filterState
      // (sanitized against STATS_WEEKS_OPTIONS on load).
      statsWeeks: 12,
      // Guards the first fetch: the tab's data loads once when it first becomes
      // active (from onTabChange, or from refreshAll in created() when the
      // restored activeTab is already 2), then only on Refresh / weeks change.
      statsLoadedOnce: false,
      stats: {
        byWeek: [], byUser: [], meta: {}, loadingWeek: false, loadingUser: false,
      },
    }
  },
  computed: {
    // Everything below that holds translated text is a computed so it re-renders on language switch.
    priorityOptions() {
      return PRIORITY_VALUES.map(n => ({ value: n, text: this.priorityText(n) }))
    },
    countryGroupOptions() {
      return COUNTRY_GROUPS.map(value => ({ value, text: this.$t(`delivery.countryGroup.${COUNTRY_GROUP_KEYS[value]}`) }))
    },
    paymentOptions() {
      return ['paid', 'partial', 'unpaid'].map(value => ({ value, title: this.$t(`delivery.payment.${value}`) }))
    },
    // selectedPayment keeps the {title, value} object it was persisted with; the
    // select shows the freshly translated option with the same value.
    paymentModel: {
      get() {
        const v = this.selectedPayment && this.selectedPayment.value
        return this.paymentOptions.find(o => o.value === v) || null
      },
      set(value) {
        this.selectedPayment = value || ''
      },
    },
    dateChangeReasons() {
      return DATE_CHANGE_REASON_CODES.map(value => ({ value, text: this.$t(`delivery.reasons.${value}`) }))
    },
    statsWeeksOptions() {
      return STATS_WEEKS_OPTIONS.map(n => ({ value: n, text: this.$t('deliveryModal.stats.weeksOption', { n }) }))
    },
    tableFields() {
      const L = key => this.$t(`delivery.cols.${key}`)
      const col = (key, label, extra = {}) => ({ key, label: L(label), ...extra })
      const sortable = (key, label, extra = {}) => col(key, label, { sortable: true, ...extra })
      const notes = col('notes', 'notes', { formatter: notesFmt })
      const dueFmt = v => this.daysText(v)
      const dueFmtS1 = (v, key, item) => (item && item.is_closed ? '—' : this.daysText(v))
      const dash = v => v || '—'
      const incoming = sortable('incoming_date', 'incoming', { headerTitle: this.$t('delivery.headerTitle.incoming') })
      const prio = sortable('priority', 'prio', { headerTitle: this.$t('delivery.headerTitle.prio') })
      return {
        e1: [
          sortable('order_no', 'lbNo'),
          sortable('supplier', 'supplier'),
          sortable('order_date', 'lbOrderDate', { formatter: dateFmt }),
          sortable('delivery_date', 'deliveryDate', { formatter: dateFmt }),
          col('pos_summary', 'positions'),
          col('status', 'status'),
          sortable('days_diff', 'due', { formatter: dueFmt }),
          sortable('order_amount', 'lbOrderAmount', { formatter: euroFmt }),
          sortable('buyer', 'buyer'),
          col('sales_order_no', 'reference'),
          notes,
        ],
        e2: [
          sortable('order_no', 'lbNo'),
          sortable('supplier', 'supplier'),
          sortable('order_date', 'lbOrderDate', { formatter: dateFmt }),
          sortable('days_since_ordered', 'daysSinceOrder'),
          sortable('buyer', 'buyer'),
          col('sales_order_no', 'reference'),
          notes,
        ],
        e3: [
          sortable('order_no', 'lbNo'),
          sortable('supplier', 'supplier'),
          sortable('order_date', 'lbOrderDate', { formatter: dateFmt }),
          sortable('age_days', 'ageDays'),
          sortable('buyer', 'buyer'),
          notes,
        ],
        e4: [
          sortable('order_no', 'orderNo'),
          sortable('order_date', 'orderDate', { formatter: dateFmt }),
          sortable('age_days', 'ageDays'),
          sortable('order_amount', 'orderAmount', { formatter: euroFmt }),
          sortable('owner', 'owner'),
          col('suggestion_reason', 'reason'),
          col('hold', 'onHold'),
          notes,
        ],
        s1: [
          sortable('order_no', 'orderNo'),
          sortable('customer', 'customer'),
          col('source', 'source'),
          sortable('order_date', 'orderDate', { formatter: dateFmt }),
          sortable('age_days', 'ageDays'),
          sortable('delivery_date', 'promisedDelivery', { formatter: dateFmt }),
          incoming,
          col('status', 'status'),
          col('hold', 'onHold'),
          sortable('payment_status', 'paid', { formatter: v => this.paymentLabel(v) }),
          sortable('payment_method', 'paymentMethod', { formatter: dash }),
          // days_diff is meaningless for closed/shipped rows, so S1 shows a dash there.
          sortable('days_diff', 'due', { formatter: dueFmtS1 }),
          sortable('order_amount', 'orderAmount', { formatter: euroFmt }),
          sortable('owner', 'owner'),
          prio,
          notes,
        ],
        s2: [
          sortable('order_no', 'orderNo'),
          sortable('customer', 'customer'),
          sortable('order_date', 'orderDate', { formatter: dateFmt }),
          sortable('age_days', 'ageDays'),
          sortable('order_amount', 'orderAmount', { formatter: euroFmt }),
          col('source', 'source'),
          col('hold', 'onHold'),
          sortable('payment_status', 'paid', { formatter: v => this.paymentLabel(v) }),
          sortable('payment_method', 'paymentMethod', { formatter: dash }),
          incoming,
          col('suggested', 'suggestedDate'),
          sortable('owner', 'owner'),
          prio,
          notes,
        ],
      }
    },
    autoQueueFields() {
      return [
        { key: 'order_no', label: this.$t('delivery.cols.orderNo') },
        { key: 'status', label: this.$t('delivery.cols.status') },
        { key: 'suggested_date', label: this.$t('delivery.cols.suggestedDate'), formatter: dateFmt },
        { key: 'suggestion_reason', label: this.$t('delivery.cols.suggestion') },
        { key: 'first_seen_at', label: this.$t('delivery.cols.since'), formatter: dateTimeFmt },
        { key: 'rejected_by', label: this.$t('delivery.cols.by'), formatter: v => v || '—' },
        { key: 'rejected_note', label: this.$t('delivery.cols.note'), formatter: v => v || '' },
        { key: 'actions', label: '' },
      ]
    },
    // Supplier LB positions (has delivered qty + lead time).
    posFields() {
      const L = key => this.$t(`delivery.cols.${key}`)
      return [
        { key: 'item_sku', label: L('sku') },
        { key: 'name', label: L('description') },
        { key: 'qty', label: L('qty') },
        { key: 'qty_delivered', label: L('delivered') },
        { key: 'delivery_date', label: L('deliveryDate'), formatter: dateFmt },
        { key: 'lead_days', label: L('leadTime') },
      ]
    },
    // Customer-order positions (prices instead of delivery info).
    orderPosFields() {
      const L = key => this.$t(`delivery.cols.${key}`)
      return [
        { key: 'item_sku', label: L('sku') },
        { key: 'name', label: L('description') },
        { key: 'delivery_time', label: L('deliveryTime') },
        { key: 'qty', label: L('qty') },
        { key: 'availability', label: L('availability') },
        { key: 'sprice', label: L('unitPrice'), formatter: euroFmt },
        { key: 'discount', label: L('discount') },
        { key: 'total_price', label: L('lineTotal'), formatter: euroFmt },
      ]
    },
    // Linked supplier orders shown inside a customer-order modal. Item-level:
    // one row per matching open PO position (linked by article, or by the
    // explicit cBezugsAuftragsNummer reference).
    linkedLbFields() {
      const L = key => this.$t(`delivery.cols.${key}`)
      return [
        { key: 'lb_no', label: L('lbNo') },
        { key: 'supplier', label: L('supplier') },
        { key: 'item', label: L('item') },
        { key: 'open_qty', label: L('openQty') },
        { key: 'status', label: L('status') },
        { key: 'delivery_date', label: L('deliveryDate') },
        { key: 'match_type', label: L('link') },
      ]
    },
    statsUserFields() {
      const L = key => this.$t(`delivery.cols.${key}`)
      return [
        { key: 'name', label: L('name'), sortable: true },
        {
          key: 'team', label: L('team'), sortable: true, formatter: v => v || '—',
        },
        { key: 'tool', label: L('viaTool'), sortable: true },
        { key: 'jtl_direct', label: L('directJtl'), sortable: true },
        { key: 'total', label: L('total'), sortable: true },
        { key: 'tool_share_pct', label: L('toolSharePct'), sortable: true },
        { key: 'hold_changes', label: L('holdChanges'), sortable: true },
        { key: 'other_actions', label: L('otherToolActions'), sortable: true },
        { key: 'last_tool_use', label: L('lastToolUse'), sortable: true },
        { key: 'last_jtl_change', label: L('lastJtlChange'), sortable: true },
      ]
    },
    // Stacked bar (tool / auto-applied / JTL direct / system-other) + a line on a
    // second y-axis for the tool's overall share. 'automatic' (JTL import
    // workflows) is deliberately omitted — it dwarfs everything else and isn't
    // part of the tool-vs-JTL comparison this chart exists to show.
    usageByWeekChart() {
      const rows = this.stats.byWeek || []
      const values = key => rows.map(r => Number(r[key] || 0))
      const name = key => this.$t(`deliveryModal.stats.series.${key}`)
      const shareSeriesIndex = 4
      return {
        color: ['#28c76f', '#a3e9c5', '#ff9f43', '#82868b', '#7367f0'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: params => {
            let result = `${params[0].name}<br/>`
            params.forEach(p => {
              const suffix = p.seriesIndex === shareSeriesIndex ? ' %' : ''
              result += `${p.marker} ${p.seriesName}: ${Number(p.value || 0).toLocaleString('de-DE')}${suffix}<br/>`
            })
            return result
          },
        },
        legend: {},
        grid: {
          left: '3%', right: '4%', bottom: '3%', containLabel: true,
        },
        xAxis: {
          type: 'category', data: rows.map(r => r.week_label), axisTick: { alignWithLabel: true },
        },
        yAxis: [
          {
            type: 'value', name: this.$t('deliveryModal.stats.changes'), position: 'left', axisLabel: { formatter: v => Number(v).toLocaleString('de-DE') },
          },
          {
            type: 'value', name: name('share'), position: 'right', min: 0, max: 100, axisLabel: { formatter: '{value} %' },
          },
        ],
        series: [
          {
            name: name('tool'), type: 'bar', stack: 'usage', yAxisIndex: 0, data: values('tool'),
          },
          {
            name: name('auto'), type: 'bar', stack: 'usage', yAxisIndex: 0, data: values('tool_auto'),
          },
          {
            name: name('jtl'), type: 'bar', stack: 'usage', yAxisIndex: 0, data: values('jtl_direct'),
          },
          {
            name: name('system'), type: 'bar', stack: 'usage', yAxisIndex: 0, data: values('system_other'),
          },
          {
            name: name('share'), type: 'line', yAxisIndex: 1, smooth: true, data: values('tool_share_pct'),
          },
        ],
      }
    },
    modalPriorityOptions() {
      const p = this.detail.header.priority
      if (p === undefined || p === null || PRIORITY_VALUES.includes(p)) return this.priorityOptions
      return [{ value: p, text: this.$t('delivery.priority.legacy', { n: p }), disabled: true }, ...this.priorityOptions]
    },
    ownerOptions() {
      return this.activeTab === 0 ? this.purchasingOwners : this.supportOwners
    },
    // Status option set for the Status v-select — purchasing (E1) and support (S1)
    // have different buckets (blocking vs. definitely late).
    statusOptions() {
      const base = this.activeTab === 0 ? PURCH_STATUS_OPTIONS : SUPPORT_STATUS_OPTIONS
      return base.map(o => ({ ...o, title: this.$t(`delivery.status.${o.value}`) }))
    },
    // The Status v-select is bound to this instead of selectedStatuses/
    // selectedStatusesPurch directly, so the same markup works for both tabs.
    // The getter returns the freshly translated options (same values as stored).
    activeStatuses: {
      get() {
        const picked = (this.activeTab === 0 ? this.selectedStatusesPurch : this.selectedStatuses).map(s => s.value)
        return this.statusOptions.filter(o => picked.includes(o.value))
      },
      set(value) {
        if (this.activeTab === 0) this.selectedStatusesPurch = value
        else this.selectedStatuses = value
      },
    },
    detailTitle() {
      return this.$t(this.detail.type === 'order' ? 'deliveryModal.detail.titleOrder' : 'deliveryModal.detail.titleLb', { no: this.detail.orderNo })
    },
    suggestionBasis() {
      return this.modalSuggestion.reason === 'stock'
        ? this.$t('deliveryModal.detail.basisStock')
        : this.$t('deliveryModal.detail.basisSupplier', { days: this.suggestionBufferDays })
    },
    // Enable the LB delivery-date Save button only when the picker differs from
    // the loaded/last-saved value (treat null/empty as equivalent).
    lbDateChanged() {
      return (this.editDeliveryDate || '') !== (this.originalDeliveryDate || '')
    },
    // Enable the order promised-delivery Save button only on an actual change.
    promisedDateChanged() {
      return (this.editPromisedDate || '') !== (this.originalPromisedDate || '')
    },
    // Muted info line above the S2 table (auto-apply-status). Built here (not
    // server-side) so it re-renders instantly when the tab-local enabled/counts
    // state updates.
    autoApplyInfoText() {
      const a = this.autoApply
      const lastRun = a.lastRunAt ? dateTimeFmt(a.lastRunAt) : '—'
      const tail = this.$t('delivery.auto.tail', { skipped: a.counts.skipped, rejected: a.counts.rejected, lastRun })
      return this.$t(a.enabled ? 'delivery.auto.on' : 'delivery.auto.off', {
        hours: a.delayHours, pending: a.counts.pending, tail,
      })
    },
    // Order-no -> S2 row lookup, so the detail modal (which has no S2 row object
    // of its own) can show the same auto-apply status. Limitation: only orders
    // currently loaded into s2.items (current page/filters) resolve — an order
    // opened via search/S1/a direct link may show no auto-apply line even when
    // it does have one.
    autoQueueByOrder() {
      const map = {};
      (this.s2.items || []).forEach(item => { if (item.order_no) map[item.order_no] = item })
      return map
    },
    // Enable the Save notes button only when a note field actually changed.
    notesChanged() {
      return (this.editNote || '') !== (this.originalNote || '')
        || (this.editComment || '') !== (this.originalComment || '')
    },
    // LB modal has only the internal comment (no separate customer note).
    commentChanged() {
      return (this.editComment || '') !== (this.originalComment || '')
    },
    // Blocked while the comment textarea is dirty: the post-add reload would drop those edits.
    addCommentDisabled() {
      return this.addingComment || this.savingNotes || this.commentChanged || !this.newCommentLine.trim()
    },
    // Domestic (Germany) vs international, derived from the order's country.
    // Empty country is treated as domestic — the large majority of orders are German.
    isDomesticOrder() {
      const c = String(this.detail.header.country || '').trim().toUpperCase()
      return ['', 'DE', 'DEU', 'DEUTSCHLAND', 'GERMANY'].includes(c)
    },
    // Buffer added on top of the supplier date: +4d Germany, +7d international.
    suggestionBufferDays() {
      return this.isDomesticOrder ? 4 : 7
    },
    // Suggested promised date {date, reason, lbNo}, following the same rules as the
    // S2 list SQL (orders_no_date_sql — change both together). Coverage is
    // reservation-aware (see positionCovered): a position also counts as covered
    // when free stock is only exhausted by this order's own reservation.
    //   - no article positions -> 'no_data';
    //   - every article position covered -> 'stock', today + 2 (DE) / 3 (intl);
    //   - otherwise classify each SHORT position's open (open_qty > 0) linked-LB
    //     rows (see positionSuggestion) and take the worst state across them,
    //     priority needs_purchasing > supplier_overdue > unconfirmed > incoming:
    //       - no linked-LB rows at all -> 'needs_purchasing', no date;
    //       - no row dated today-or-later, at least one dated in the past, no
    //         undated row -> 'supplier_overdue', no date (lbNo = a deciding row);
    //       - no row dated today-or-later (only undated, possibly + past)
    //         -> 'unconfirmed', no date (lbNo = a deciding row);
    //       - else 'incoming' = MAX across positions of the earliest
    //         today-or-later date (ship-complete) + 4/7 buffer.
    modalSuggestion() {
      const positions = (this.detail.positions || []).filter(this.isStockPosition)
      if (!positions.length) return { date: '', reason: 'no_data', lbNo: '' }
      const shorts = positions.filter(p => !this.positionCovered(p))
      if (!shorts.length) {
        return { date: addDaysYmd(todayYmd(), this.isDomesticOrder ? 2 : 3), reason: 'stock', lbNo: '' }
      }
      const results = shorts.map(p => this.positionSuggestion(p.item_sku))
      const worst = state => results.find(r => r.state === state)
      if (worst('needs_purchasing')) return { date: '', reason: 'needs_purchasing', lbNo: '' }
      const overdue = worst('supplier_overdue')
      if (overdue) return { date: '', reason: 'supplier_overdue', lbNo: overdue.lbNo }
      const unconfirmed = worst('unconfirmed')
      if (unconfirmed) return { date: '', reason: 'unconfirmed', lbNo: unconfirmed.lbNo }
      const base = results.map(r => r.date).sort().slice(-1)[0] // max, lexicographic on YYYY-MM-DD
      return { date: addDaysYmd(base, this.suggestionBufferDays), reason: 'incoming', lbNo: '' }
    },
    // Paid Vorkasse orders promise "delivery X days after payment", so the +N
    // quick buttons count from the payment date there (agreed 2026-10-29).
    quickDateBase() {
      const h = this.detail.header || {}
      const vorkasse = String(h.payment_method || '').startsWith('Vorkasse')
      return vorkasse && h.paid_date ? String(h.paid_date).slice(0, 10) : todayYmd()
    },
    // Kept as the single "suggested date" accessor (seeds the picker on load).
    suggestedPromisedDate() {
      return this.modalSuggestion.date
    },
    // Latest (max) dated arrival across the linked supplier orders, as YYYY-MM-DD
    // ('' when none carry a date). Basis for the date-mismatch warning.
    maxIncomingDate() {
      const dates = (this.detail.linkedLbs || [])
        .map(lb => lb.delivery_date)
        .filter(Boolean)
        .map(d => String(d).slice(0, 10))
      return dates.length ? dates.sort().slice(-1)[0] : ''
    },
    // True when the order has a saved promised date AND a linked supplier order is
    // due to arrive after it — we cannot ship on time (e.g. SB40780: promised 30.06,
    // supplier 03.07). Compares against the saved date, not the picker.
    promisedLate() {
      return !!(this.originalPromisedDate && this.maxIncomingDate
        && this.maxIncomingDate > this.originalPromisedDate)
    },
    // A linked supplier arrival this order waits on is already overdue: dated in
    // the past but goods not arrived (open_qty > 0) — the SB41304 case. Whatever
    // plan the promised date was based on has already failed, even when the
    // promised date itself still lies in the future.
    supplierMissed() {
      const today = todayYmd()
      return (this.detail.linkedLbs || []).some(lb => lb.delivery_date
        && Number(lb.open_qty) > 0
        && String(lb.delivery_date).slice(0, 10) < today)
    },
    // Partial-delivery hint: some article positions shippable from stock now while
    // others are short. remainderDate = latest expected arrival of the short
    // positions ('' when any of them has no dated incoming -> shown as TBD).
    // Coverage uses positionCovered (reservation-aware, see modalSuggestion above).
    partialDelivery() {
      const positions = (this.detail.positions || []).filter(this.isStockPosition)
      const inStock = positions.filter(p => this.positionCovered(p))
      const shorts = positions.filter(p => !this.positionCovered(p))
      if (!inStock.length || !shorts.length) return null
      const arrivals = shorts.map(p => this.earliestIncomingYmd(p.item_sku)).filter(Boolean)
      const remainderDate = arrivals.length === shorts.length ? arrivals.sort().slice(-1)[0] : ''
      return { available: inStock.length, total: positions.length, remainderDate }
    },
    // Aggregate of every filter field — a single watcher on this persists the
    // whole set (a new array reference is produced whenever any field changes).
    filterState() {
      return [
        this.activeTab, this.searchValue, this.selectedOwner, this.selectedPlatform,
        this.selectedCountryGroup, this.selectedPriority, this.selectedPayment, this.selectedStatuses,
        this.selectedStatusesPurch, this.onlyMine, this.createdAfter, this.daysNoDate,
        this.statsWeeks,
      ]
    },
    // Endpoint config per list key.
    endpoints() {
      return {
        e1: `${API}/delivery-dashboard/lb-due-soon/`,
        e2: `${API}/delivery-dashboard/lb-unconfirmed/`,
        e3: `${API}/delivery-dashboard/lb-no-date/`,
        e4: `${API}/delivery-dashboard/orders-no-date/`,
        s1: `${API}/delivery-dashboard/orders-due-soon/`,
        s2: `${API}/delivery-dashboard/orders-no-date/`,
      }
    },
    // Real row count for the E4 header badge (e4.totalRows is doubled — see the
    // b-pagination workaround in getList — so it isn't a display count).
    e4Count() {
      return (this.e4.items[0] && this.e4.items[0].count) || 0
    },
    // Statistics-tab KPI tiles, computed client-side from the by-week results so
    // they always agree with the chart (same data, same window).
    statsKpi() {
      const rows = this.stats.byWeek || []
      const sum = key => rows.reduce((acc, r) => acc + Number(r[key] || 0), 0)
      const tool = sum('tool')
      const toolAuto = sum('tool_auto')
      const jtlDirect = sum('jtl_direct')
      const systemOther = sum('system_other')
      const denom = tool + toolAuto + jtlDirect + systemOther
      return {
        tool,
        toolAuto,
        jtlDirect,
        systemOther,
        sharePct: denom > 0 ? ((tool + toolAuto) / denom) * 100 : null,
      }
    },
  },
  watch: {
    // Popover lines are cached as translated text.
    '$i18n.locale': function resetIncomingCache() {
      this.incomingCache = {}
    },
    // Auto-remember the filter state per user (no explicit save button).
    filterState() {
      this.saveFilters()
    },
    // Clear the reason picker once the picker is back at the saved date (the
    // reason row hides via v-if="promisedDateChanged" — no point keeping a
    // stale reason around for the next edit).
    promisedDateChanged(changed) {
      if (!changed) {
        this.editReason = ''
        this.editReasonNote = ''
      }
    },
    // Refetch both Statistics requests when the window changes — but only once
    // the tab has actually been visited (before that there's nothing loaded yet;
    // the first load happens from onTabChange/refreshAll instead).
    statsWeeks() {
      if (this.statsLoadedOnce) this.refreshStats()
    },
  },
  async created() {
    // Restore the user's last filters before the initial fetch. Runs in created()
    // (before the tab bar mounts) so setting activeTab doesn't fire onTabChange,
    // whose clearing logic would wipe the restored owner/platform/payment filters.
    this.loadFilters()
    // URL deep-link (see the contract comment at the top of this file) —
    // overrides the just-restored persisted values, same ordering rationale:
    // set activeTab/status directly here (before the tab bar mounts) rather
    // than via onTabChange, so its owner-clearing logic doesn't run and wipe
    // what we're about to set.
    const urlQuery = this.$route.query || {}
    const hasUrlParams = !!(urlQuery.tab || urlQuery.owner || urlQuery.buyer || urlQuery.status)
    if (hasUrlParams) {
      this.searchValue = ''
      this.onlyMine = false
      this.applyUrlTabAndStatus(urlQuery)
    }
    try {
      if (hasUrlParams) {
        // owner/buyer resolution needs ownerOptions — load them first, then
        // apply, then fetch, instead of the normal Promise.all below.
        await this.loadOwners()
        this.applyUrlOwnerBuyer(urlQuery)
        await this.refreshAll()
        this.clearUrlQuery()
      } else {
        await Promise.all([this.loadOwners(), this.refreshAll()])
      }
    } catch (error) {
      if (error.response && error.response.status === 401) this.$router.push({ name: 'login' })
    }
  },
  methods: {
    // Per-user localStorage key so filters follow the logged-in user, not the browser.
    filtersStorageKey() {
      const uid = localStorage.getItem('useridLocal') || 'anon'
      return `deliveryDashboardFilters:${uid}`
    },
    saveFilters() {
      try {
        localStorage.setItem(this.filtersStorageKey(), JSON.stringify({
          activeTab: this.activeTab,
          searchValue: this.searchValue,
          selectedOwner: this.selectedOwner,
          selectedPlatform: this.selectedPlatform,
          selectedCountryGroup: this.selectedCountryGroup,
          selectedPriority: this.selectedPriority,
          selectedPayment: this.selectedPayment,
          selectedStatuses: this.selectedStatuses,
          selectedStatusesPurch: this.selectedStatusesPurch,
          onlyMine: this.onlyMine,
          createdAfter: this.createdAfter,
          daysNoDate: this.daysNoDate,
          statsWeeks: this.statsWeeks,
        }))
      } catch (e) { /* ignore quota / serialization errors */ }
    },
    loadFilters() {
      try {
        const raw = localStorage.getItem(this.filtersStorageKey())
        if (!raw) return
        const b = JSON.parse(raw)
        // Sanitize a stored status array against a canonical option set: keep only
        // entries whose value still exists (drops stale/renamed values, e.g. an
        // old blob from before this option was added).
        const pick = (arr, opts) => (Array.isArray(arr)
          ? arr.map(s => opts.find(o => o.value === (s && s.value))).filter(Boolean)
          : null)
        if (typeof b.activeTab === 'number') this.activeTab = b.activeTab
        if (typeof b.searchValue === 'string') this.searchValue = b.searchValue
        if ('selectedOwner' in b) this.selectedOwner = b.selectedOwner || ''
        if ('selectedPlatform' in b) this.selectedPlatform = b.selectedPlatform || ''
        if ('selectedCountryGroup' in b) {
          // Stored as a single string before the filter became multi-select.
          const groups = [].concat(b.selectedCountryGroup || [])
          this.selectedCountryGroup = groups.filter(g => COUNTRY_GROUPS.includes(g))
        }
        if ('selectedPriority' in b) {
          this.selectedPriority = [].concat(b.selectedPriority || [])
            .filter(v => PRIORITY_VALUES.includes(v))
        }
        if ('selectedPayment' in b) this.selectedPayment = b.selectedPayment || ''
        const supportPicked = pick(b.selectedStatuses, SUPPORT_STATUS_OPTIONS)
        if (supportPicked) this.selectedStatuses = supportPicked
        if ('selectedStatusesPurch' in b) {
          const purchPicked = pick(b.selectedStatusesPurch, PURCH_STATUS_OPTIONS)
          if (purchPicked) this.selectedStatusesPurch = purchPicked
        } else if (Array.isArray(b.selectedStatuses)) {
          // Migration from before the tabs had separate status filters: derive the
          // purchasing selection from the legacy shared array (its dated values
          // still map onto the purchasing options) plus the new "blocking" chip,
          // to keep the always-on blocking behaviour by default. An empty legacy
          // selection ("all") stays empty rather than gaining a chip.
          const legacyDated = b.selectedStatuses
            .map(s => s && s.value)
            .filter(v => ['overdue', 'due_soon', 'no_date'].includes(v))
          this.selectedStatusesPurch = legacyDated.length
            ? PURCH_STATUS_OPTIONS.filter(o => legacyDated.includes(o.value) || o.value === 'blocking')
            : []
        }
        if (typeof b.onlyMine === 'boolean') this.onlyMine = b.onlyMine
        if (typeof b.createdAfter === 'string') this.createdAfter = b.createdAfter
        if (typeof b.daysNoDate === 'number') this.daysNoDate = b.daysNoDate
        if (typeof b.statsWeeks === 'number' && STATS_WEEKS_OPTIONS.includes(b.statsWeeks)) {
          this.statsWeeks = b.statsWeeks
        }
        // Migration from the removed "Critical only" switch: fold it into the new
        // "Definitely late" status chip so the narrowed view is preserved.
        if (b.criticalOnly === true) {
          this.selectedStatuses = SUPPORT_STATUS_OPTIONS.filter(o => o.value === 'definitely_late')
        }
      } catch (e) { /* ignore corrupt storage */ }
    },
    // ===================== URL DEEP-LINK (WP-2) =====================
    // See the contract comment at the top of this file. Sets activeTab and the
    // matching status multi-select from the URL query; called from created()
    // before the first fetch.
    applyUrlTabAndStatus(query) {
      if (query.tab === 'purchasing') this.activeTab = 0
      else if (query.tab === 'support') this.activeTab = 1
      if (!query.status) return
      const values = String(query.status).split(',').map(s => s.trim()).filter(Boolean)
      if (this.activeTab === 0) {
        this.selectedStatusesPurch = values
          .map(v => PURCH_STATUS_OPTIONS.find(o => o.value === v))
          .filter(Boolean)
      } else {
        this.selectedStatuses = values
          .map(v => SUPPORT_STATUS_OPTIONS.find(o => o.value === v))
          .filter(Boolean)
      }
    },
    // Resolves a URL id (string) against a loaded owner/buyer option list,
    // falling back to a synthetic option so the server-side filter still
    // applies even when the id isn't found (e.g. options still loading oddly,
    // or a since-removed user).
    resolveOwnerOption(options, idStr) {
      const id = Number(idStr)
      const match = (options || []).find(o => Number(o.value) === id)
      return match || { title: `#${id}`, value: id }
    },
    // Applies owner (support tab) / buyer (purchasing tab) from the URL query
    // into selectedOwner. Must run AFTER loadOwners() has populated
    // supportOwners/purchasingOwners; called from created() once that resolves.
    applyUrlOwnerBuyer(query) {
      if (this.activeTab === 1 && query.owner) {
        this.selectedOwner = this.resolveOwnerOption(this.supportOwners, query.owner)
      } else if (this.activeTab === 0 && query.buyer) {
        this.selectedOwner = this.resolveOwnerOption(this.purchasingOwners, query.buyer)
      }
    },
    // Strips the deep-link query params from the URL without a reload, so a
    // later plain reload falls back to the persisted filters as usual. The
    // NavigationDuplicated error (replacing with an already-empty query) is
    // expected and harmless.
    clearUrlQuery() {
      this.$router.replace({ query: {} }).catch(() => {})
    },
    async makeRequest(url, params) {
      return axios.get(url, {
        headers: { Authorization: `JWT ${this.$store.state.jwt}`, 'Content-Type': 'application/json' },
        params,
      })
    },
    baseParams(extra = {}) {
      const p = { ...extra }
      if (this.searchValue) p.search = `%${this.searchValue.toLowerCase()}%`
      if (this.onlyMine) p.only_mine = 'true'
      else if (this.selectedOwner && this.selectedOwner.value) p.owner_id = this.selectedOwner.value
      if (this.createdAfter) p.created_after = this.createdAfter
      // Support-only filters (ignored by the LB endpoints, which lack the params).
      // Send only when set — an empty value would become a filter matching nothing.
      if (this.selectedPlatform && this.selectedPlatform.value !== undefined) p.platform = this.selectedPlatform.value
      if (this.selectedCountryGroup.length) p.country_group = this.selectedCountryGroup
      if (this.selectedPriority.length) p.priority = this.selectedPriority
      if (this.selectedPayment && this.selectedPayment.value) p.payment_status = this.selectedPayment.value
      return p
    },
    listParams(key, extra = {}) {
      if (key === 'e4') {
        // E4 lives on the Purchasing tab but calls the S2 (orders-no-date)
        // endpoint with purchasing_only=1. Deliberately NOT built from
        // baseParams(): on the Purchasing tab selectedOwner/onlyMine are bound
        // to the LB buyer dimension (ownerOptions -> purchasingOwners), but
        // orders-no-date's owner_id/only_mine filter by the customer ORDER
        // owner (a.kBenutzer) — a different person entirely. Sending them
        // through would silently filter E4 by the wrong dimension, so only the
        // owner-agnostic filters (search, created_after) carry over, along
        // with paging/export/ordering merged in via extra. The Purchasing
        // status multi-select (selectedStatusesPurch) doesn't apply to E4
        // either — it maps to want_overdue/want_due_soon/etc., which the
        // needs_purchasing/supplier_overdue rows don't have.
        const p = { ...extra, purchasing_only: '1' }
        if (this.searchValue) p.search = `%${this.searchValue.toLowerCase()}%`
        if (this.createdAfter) p.created_after = this.createdAfter
        return p
      }
      const p = this.baseParams(extra)
      // Purchasing uses :supplier, support uses :days_no_date — both harmless if unused.
      if (key === 's2') p.days_no_date = this.daysNoDate
      const supportPicked = (this.selectedStatuses || []).map(s => s.value)
      if ((key === 's1' || key === 's2') && supportPicked.includes('partial_delivery')) p.partial_only = '1'
      // Status multi-select applies only to the due-soon lists (S1 orders, E1 LBs).
      // Map the selected buckets to the backend flags. Empty selection = show all.
      if (key === 's1') {
        const picked = supportPicked.filter(v => v !== 'partial_delivery')
        const none = picked.length === 0
        p.want_overdue = none || picked.includes('overdue') ? '1' : '0'
        p.want_due_soon = none || picked.includes('due_soon') ? '1' : '0'
        p.want_no_date = none || picked.includes('no_date') ? '1' : '0'
        p.want_definitely_late = none || picked.includes('definitely_late') ? '1' : '0'
        p.want_later = none || picked.includes('later') ? '1' : '0'
        // Closed/shipped orders (last 12mo) are only worth returning when the user
        // is hunting for a specific order/LB number — an absent param means '0'
        // server-side, so plain browsing never sees closed rows.
        if (this.searchValue) p.include_closed = '1'
      }
      if (key === 'e1') {
        const picked = (this.selectedStatusesPurch || []).map(s => s.value)
        const none = picked.length === 0
        p.want_overdue = none || picked.includes('overdue') ? '1' : '0'
        p.want_due_soon = none || picked.includes('due_soon') ? '1' : '0'
        p.want_no_date = none || picked.includes('no_date') ? '1' : '0'
        p.want_blocking = none || picked.includes('blocking') ? '1' : '0'
      }
      return p
    },
    async loadOwners() {
      const [sup, buy, plat] = await Promise.all([
        this.makeRequest(`${API}/delivery-dashboard/order-owners/`, {}),
        this.makeRequest(`${API}/delivery-dashboard/lb-buyers/`, {}),
        this.makeRequest(`${API}/delivery-dashboard/order-platforms/`, {}),
      ])
      this.supportOwners = (sup.data.results || []).map(o => ({ title: o.title, value: o.value }))
      this.purchasingOwners = (buy.data.results || []).map(o => ({ title: o.title, value: o.value }))
      this.platformOptions = (plat.data.results || []).map(o => ({ title: o.title, value: o.value }))
    },
    async getSummary() {
      const params = this.baseParams({ days_no_date: this.daysNoDate })
      const [sup, pur] = await Promise.all([
        this.makeRequest(`${API}/delivery-dashboard/support-summary/`, params),
        this.makeRequest(`${API}/delivery-dashboard/purchasing-summary/`, params),
      ])
      const s = (sup.data.results && sup.data.results[0]) || {}
      const p = (pur.data.results && pur.data.results[0]) || {}
      this.summary = {
        support_overdue: s.support_overdue || 0,
        support_no_date: s.support_no_date || 0,
        support_definitely_late: s.support_definitely_late || 0,
        support_overdue_unpaid: s.support_overdue_unpaid || 0,
        support_no_date_unpaid: s.support_no_date_unpaid || 0,
        support_definitely_late_unpaid: s.support_definitely_late_unpaid || 0,
        purchasing_overdue: p.purchasing_overdue || 0,
        lb_unconfirmed: p.lb_unconfirmed || 0,
        backorder_danger: p.backorder_danger || 0,
        backorder_warn: p.backorder_warn || 0,
        backorder_supplier_stock: p.backorder_supplier_stock || 0,
        backorder_lb_no: p.backorder_lb_no || '',
      }
    },
    async getList(key) {
      const t = this[key]
      // S1/S2 refresh: drop the Incoming-column popover cache so a stale
      // position breakdown can't survive under a re-fetched row.
      if (key === 's1' || key === 's2') this.incomingCache = {}
      const params = this.listParams(key, { page: t.currentPage })
      if (t.sortBy) params.ordering = t.sortDesc ? `-${t.sortBy}` : t.sortBy
      const res = await this.makeRequest(this.endpoints[key], params)
      const results = res.data.results || []
      if (results.length > 0) {
        t.items = results
        // count is total rows (COUNT(*) OVER()); *2 matches b-pagination default per-page=20.
        t.totalRows = (results[0].count || results.length) * 2
      } else {
        t.items = []
        t.totalRows = 0
      }
      // S2-only: refresh the auto-apply info line together with the list, and
      // the review card's rows if it's currently open.
      if (key === 's2') {
        await this.fetchAutoApplyStatus()
        if (this.showAutoQueue) await this.fetchAutoQueue()
      }
    },
    async refreshAll() {
      await this.getSummary()
      if (this.activeTab === 2) {
        // Statistics tab has no owner/date/status filters of its own — load it
        // once (first visit, including a restored activeTab === 2 on page load)
        // and leave it alone otherwise; Refresh/the weeks selector handle the rest.
        if (!this.statsLoadedOnce) {
          this.statsLoadedOnce = true
          await this.refreshStats()
        }
        return
      }
      await Promise.all(
        // Backorder list is loaded only from here (refs exist after the awaited summary).
        this.activeTab === 0 ? [this.getList('e1'), this.getList('e2'), this.getList('e3'), this.getList('e4'),
          this.$refs.backorderList && this.$refs.backorderList.refresh()]
          : [this.getList('s1'), this.getList('s2')],
      )
    },
    // Back to the page defaults (statuses and no-date age included), not to empty.
    async clearFilters() {
      this.searchValue = ''
      this.selectedOwner = ''
      this.createdAfter = ''
      this.onlyMine = false
      this.daysNoDate = 3
      this.selectedPlatform = ''
      this.selectedCountryGroup = []
      this.selectedPriority = []
      this.selectedPayment = ''
      this.selectedStatuses = SUPPORT_STATUS_OPTIONS.filter(o => DEFAULT_SUPPORT_STATUSES.includes(o.value))
      this.selectedStatusesPurch = PURCH_STATUS_OPTIONS.filter(o => DEFAULT_PURCH_STATUSES.includes(o.value))
      await this.applyFilters()
    },
    async applyFilters() {
      ['e1', 'e2', 'e3', 'e4', 's1', 's2'].forEach(k => { this[k].currentPage = 1 })
      await this.refreshAll()
    },
    // ===================== STATISTICS (tool usage) =====================
    async fetchUsageByWeek() {
      this.stats.loadingWeek = true
      try {
        const res = await this.makeRequest(`${API}/delivery-dashboard/usage-by-week/`, { weeks: this.statsWeeks })
        const results = res.data.results || []
        this.stats.byWeek = results
        this.stats.meta = res.data.meta || {}
      } catch (error) {
        this.showToast('danger', this.$t('deliveryModal.toast.usageWeekError'))
      } finally {
        this.stats.loadingWeek = false
      }
    },
    async fetchUsageByUser() {
      this.stats.loadingUser = true
      try {
        const res = await this.makeRequest(`${API}/delivery-dashboard/usage-by-user/`, { weeks: this.statsWeeks })
        this.stats.byUser = res.data.results || []
      } catch (error) {
        this.showToast('danger', this.$t('deliveryModal.toast.usageUserError'))
      } finally {
        this.stats.loadingUser = false
      }
    },
    async refreshStats() {
      await Promise.all([this.fetchUsageByWeek(), this.fetchUsageByUser()])
    },
    // Badge variant for the by-user Tool share % column (only meaningful when the
    // row has any activity at all — see the v-else "—" in the template).
    statsShareVariant(pct) {
      const n = Number(pct)
      if (n >= 70) return 'success'
      if (n >= 30) return 'warning'
      return 'danger'
    },
    // System rows (Webshop Import, System/Worker) read as muted; real users with
    // any activity but no tool action of any kind are the people Lukas wants to talk to.
    statsUserRowClass(item) {
      if (!item) return ''
      if (item.is_system) return 'text-muted'
      const toolActions = Number(item.tool) + Number(item.other_actions || 0)
      if (Number(item.total) > 0 && toolActions === 0) return 'table-danger'
      return ''
    },
    otherActionsTooltip(item) {
      const label = action => (this.$te(`deliveryModal.stats.actions.${action}`) ? this.$t(`deliveryModal.stats.actions.${action}`) : action)
      return Object.entries(item.other_actions_by_type || {})
        .sort((a, b) => b[1] - a[1])
        .map(([action, n]) => `${label(action)}: ${n}`)
        .join(', ')
    },
    dateTimeFmt(v) { return dateTimeFmt(v) },
    async onTabChange() {
      // Owner options differ per tab (buyers vs. support owners); a selection
      // carried over from the other tab would silently keep filtering. The
      // platform/country-group filters are support-only — clear them too so they
      // don't linger (and stay hidden) on the purchasing tab.
      this.selectedOwner = ''
      this.selectedPlatform = ''
      this.selectedCountryGroup = []
      this.selectedPriority = []
      this.selectedPayment = ''
      if (this.pendingCardApply) {
        // A KPI card triggered this tab switch — apply its filter/scroll instead of
        // a plain refresh, so we don't fetch twice.
        const kind = this.pendingCardApply
        this.pendingCardApply = ''
        await this.applyCard(kind)
      } else {
        await this.refreshAll()
      }
    },
    // KPI-card click: jump to the tab that owns this figure, apply the matching
    // filter, then scroll to (and, for the two cards with no filter of their own,
    // flash-highlight) the relevant table. If we're already on the right tab,
    // apply immediately; otherwise switch tabs first — onTabChange picks up
    // pendingCardApply and calls applyCard itself once the switch has happened,
    // so we only fetch once.
    onCardClick(kind) {
      const target = ['purchasing_overdue', 'lb_unconfirmed', 'backorder'].includes(kind) ? 0 : 1
      if (this.activeTab === target) {
        this.applyCard(kind)
      } else {
        this.pendingCardApply = kind
        this.activeTab = target
      }
    },
    async applyCard(kind) {
      if (kind === 'support_overdue') {
        this.selectedStatuses = SUPPORT_STATUS_OPTIONS.filter(o => o.value === 'overdue')
      }
      if (kind === 'definitely_late') {
        this.selectedStatuses = SUPPORT_STATUS_OPTIONS.filter(o => o.value === 'definitely_late')
      }
      if (kind === 'purchasing_overdue') {
        this.selectedStatusesPurch = PURCH_STATUS_OPTIONS.filter(o => o.value === 'overdue')
      }
      // support_no_date / lb_unconfirmed: no filter change — their tables (S2, E2)
      // already show exactly the card's population, so just scroll to them.
      await this.applyFilters()
      await this.$nextTick()
      const ref = {
        support_overdue: 's1Card',
        definitely_late: 's1Card',
        purchasing_overdue: 'e1Card',
        support_no_date: 's2Card',
        lb_unconfirmed: 'e2Card',
        backorder: 'backorderList',
      }[kind]
      const el = this.$refs[ref] && (this.$refs[ref].$el || this.$refs[ref])
      if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      if ((kind === 'support_no_date' || kind === 'lb_unconfirmed') && el) {
        el.classList.add('flash-highlight')
        setTimeout(() => el.classList.remove('flash-highlight'), 2000)
      }
    },
    async pageChange(key, value) {
      this[key].currentPage = value
      await this.getList(key)
    },
    async sortChanged(key, ctx) {
      this[key].sortBy = ctx.sortBy
      this[key].sortDesc = ctx.sortDesc
      this[key].currentPage = 1
      await this.getList(key)
    },
    fmtDate(v) { return dateFmt(v) },
    euro(v) { return euroFmt(v) },
    daysText(v) {
      if (v === null || v === undefined || v === '') return ''
      if (v > 0) return this.$t('delivery.due.in', { n: v })
      if (v < 0) return this.$t('delivery.due.overdue', { n: -v })
      return this.$t('delivery.due.today')
    },
    priorityText(n) {
      const key = PRIORITY_TEXT_KEYS[n]
      return key ? this.$t(`delivery.priority.${key}`, { n }) : String(n)
    },
    // Only stock-managed article lines can be short: freight/no-SKU lines have no
    // article_id and service articles (customs fees) are cLagerAktiv='N'. Mirrors
    // the tArtikel join in _INCOMING_APPLY.
    isStockPosition(p) {
      return p.article_id > 0 && Number(p.stock_managed) === 1
    },
    // A position of THIS order counts as covered when free stock suffices, or when
    // free stock is only exhausted by the order's own reservation (fVerfuegbar
    // already subtracts it): available >= 0 with physical stock covering the line.
    // Must mirror the coverage predicate in orders_no_date_sql's sug OUTER APPLY.
    positionCovered(p) {
      const avail = Number(p.available_qty)
      const qty = Number(p.qty)
      return avail >= qty || (avail >= 0 && Number(p.physical_qty) >= qty)
    },
    // Availability badge state for a position: 'available' (free stock covers the
    // line), 'reserved' (only covered via this order's own reservation — see
    // positionCovered), or 'out' (genuinely short).
    availabilityState(p) {
      if (Number(p.available_qty) > 0) return 'available'
      if (this.positionCovered(p)) return 'reserved'
      return 'out'
    },
    // Expected incoming date for a position's SKU, derived from the already-loaded
    // linked supplier orders (no extra request). Returns the earliest dated arrival,
    // 'TBD' when a matching LB exists but carries no date, or '' when none match.
    // Positions-table hint next to an out-of-stock badge. Only open (open_qty > 0)
    // linked-LB rows count; a past arrival is never shown as "incoming" — it reads
    // "overdue since DD.MM.YYYY" instead (same rule set as positionSuggestion).
    // linkedLbs defaults to the detail modal's own list; the Incoming-column
    // popover passes the linked-LBs it fetched for a DIFFERENT (not-open) order.
    incomingForSku(sku, linkedLbs = this.detail.linkedLbs) {
      if (!sku) return ''
      const lbs = (linkedLbs || []).filter(lb => lb.item_sku === sku && Number(lb.open_qty) > 0)
      if (!lbs.length) return ''
      const today = todayYmd()
      const dates = lbs.map(lb => lb.delivery_date).filter(Boolean).map(d => String(d).slice(0, 10)).sort()
      const future = dates.filter(d => d >= today)
      if (future.length) return this.$t('delivery.incomingHint.incoming', { date: dateFmt(future[0]) })
      if (dates.length && !lbs.some(lb => !lb.delivery_date)) return this.$t('delivery.incomingHint.overdueSince', { date: dateFmt(dates[0]) })
      return this.$t('delivery.incomingHint.incomingTbd')
    },
    // Delivery-time column (order positions only): what we claimed in the webshop
    // when the customer ordered. JTL keeps no history, so the backend infers it —
    // see delivery_time_state below. article_modified/delivery_time* may arrive as
    // 0 for NULL (fillna) — falsy checks handle that the same as a missing value.
    deliveryTimeValue(item) {
      if (!item) return '—'
      const state = item.delivery_time_state
      if (state === 'snapshot') return item.delivery_time_at_order || '—'
      if (state === 'unchanged' || state === 'maybe_changed') return item.delivery_time || '—'
      return '—'
    },
    // Second line under the value: what the number reflects and how sure we are.
    deliveryTimeHint(item) {
      if (!item) return ''
      const state = item.delivery_time_state
      if (state === 'snapshot') return this.$t('deliveryModal.deliveryTime.atOrder')
      if (state === 'unchanged') {
        return item.article_modified
          ? this.$t('deliveryModal.deliveryTime.unchangedSince', { date: dateFmt(item.article_modified) })
          : this.$t('deliveryModal.deliveryTime.unchanged')
      }
      if (state === 'maybe_changed') {
        return item.article_modified
          ? this.$t('deliveryModal.deliveryTime.currentSince', { date: dateFmt(item.article_modified) })
          : this.$t('deliveryModal.deliveryTime.current')
      }
      return ''
    },
    deliveryTimeTooltip(item) {
      if (!item) return ''
      const keys = { snapshot: 'tipSnapshot', unchanged: 'tipUnchanged', maybe_changed: 'tipMaybeChanged' }
      const key = keys[item.delivery_time_state]
      return key ? this.$t(`deliveryModal.deliveryTime.${key}`) : ''
    },
    // Earliest TODAY-OR-LATER dated arrival for a SKU's open (open_qty > 0)
    // linked-LB rows ('' when none — nothing ordered, only undated/unconfirmed
    // rows, or only overdue/past-dated rows). Used by partialDelivery's remainder
    // date: a past-only or undated SKU reads as TBD there, matching the
    // positionSuggestion/modalSuggestion rules above (a past arrival is never
    // used as an expected date any more). linkedLbs defaults to the detail modal's
    // own list — see incomingForSku.
    earliestIncomingYmd(sku, linkedLbs = this.detail.linkedLbs) {
      if (!sku) return ''
      const today = todayYmd()
      const dates = (linkedLbs || [])
        .filter(lb => lb.item_sku === sku && Number(lb.open_qty) > 0)
        .map(lb => lb.delivery_date)
        .filter(Boolean)
        .map(d => String(d).slice(0, 10))
        .filter(d => d >= today)
      return dates.length ? dates.sort()[0] : ''
    },
    // Classifies a single short position's open (open_qty > 0) linked-LB rows into
    // one of the SKU-level states used by modalSuggestion, in priority order:
    //   - no rows at all -> 'needs_purchasing';
    //   - a row dated today-or-later exists -> 'incoming', date = the earliest one;
    //   - else at least one undated row -> 'unconfirmed' (JTL placeholder date not
    //     yet replaced by the supplier, even if a past-dated row also exists);
    //   - else (only past-dated rows) -> 'supplier_overdue'.
    // lbNo is the LB number of whichever row decided a non-'incoming' state (any
    // one is fine — only used for the badge/hint). date is only meaningful for
    // 'incoming' (modalSuggestion relies on that); the 'supplier_overdue' date is
    // filled in too (the overdue arrival date, for the Incoming-column popover)
    // but existing callers that don't want it simply don't read it. linkedLbs
    // defaults to the detail modal's own list — see incomingForSku.
    positionSuggestion(sku, linkedLbs = this.detail.linkedLbs) {
      const today = todayYmd()
      const rows = (linkedLbs || [])
        .filter(lb => lb.item_sku === sku && Number(lb.open_qty) > 0)
      if (!rows.length) return { state: 'needs_purchasing', date: '', lbNo: '' }
      const dated = rows
        .filter(lb => lb.delivery_date)
        .map(lb => ({ lbNo: lb.lb_no, ymd: String(lb.delivery_date).slice(0, 10) }))
      const undated = rows.filter(lb => !lb.delivery_date)
      const future = dated.filter(d => d.ymd >= today).sort((a, b) => (a.ymd < b.ymd ? -1 : 1))
      if (future.length) return { state: 'incoming', date: future[0].ymd, lbNo: future[0].lbNo }
      if (undated.length) return { state: 'unconfirmed', date: '', lbNo: undated[0].lb_no }
      return { state: 'supplier_overdue', date: dated[0].ymd, lbNo: dated[0].lbNo }
    },
    // ===================== S1/S2 "Incoming" column popover =====================
    // DOM id for the popover's target element — must be unique across both lists
    // (an order_no only ever appears in one of them, but the id space is shared).
    incomingCellId(listKey, orderNo) {
      return `inc-${listKey}-${String(orderNo).replace(/[^A-Za-z0-9_-]/g, '_')}`
    },
    // Cache read with a safe default so the template never has to guard for a
    // not-yet-fetched order.
    incomingEntry(orderNo) {
      return this.incomingCache[orderNo] || { loading: false, error: false, lines: [] }
    },
    // Per-position line for the popover, reusing the same coverage/incoming rules
    // as the detail modal (positionCovered/positionSuggestion) against the
    // explicitly-passed linkedLbs (this order isn't necessarily the one open in
    // the modal, so it can't rely on this.detail.linkedLbs).
    incomingPositionLine(p, linkedLbs) {
      const sku = p.item_sku
      const qty = Number(p.qty)
      if (this.positionCovered(p)) {
        return {
          sku, qty, text: this.$t('delivery.popover.inStock'), variant: 'success',
        }
      }
      const sug = this.positionSuggestion(sku, linkedLbs)
      if (sug.state === 'incoming') {
        return {
          sku, qty, text: `${dateFmt(sug.date)} · ${sug.lbNo}`, variant: '',
        }
      }
      if (sug.state === 'unconfirmed') {
        return {
          sku, qty, text: this.$t('delivery.popover.unconfirmed', { lb: sug.lbNo }), variant: 'warning',
        }
      }
      if (sug.state === 'supplier_overdue') {
        return {
          sku, qty, text: this.$t('delivery.popover.overdueSince', { date: dateFmt(sug.date), lb: sug.lbNo }), variant: 'danger',
        }
      }
      return {
        sku, qty, text: this.$t('delivery.popover.notOrdered'), variant: 'danger',
      }
    },
    // Lazy-loads the popover's per-position breakdown on first hover (@show),
    // via the same endpoints the detail modal uses. Cached per order_no so
    // re-hovering doesn't re-fetch; cleared in getList() on every S1/S2 refresh.
    async loadIncomingPopover(orderNo) {
      if (!orderNo || this.incomingCache[orderNo]) return
      this.$set(this.incomingCache, orderNo, { loading: true, error: false, lines: [] })
      try {
        const params = { order_no: orderNo }
        const [pos, lbs] = await Promise.all([
          this.makeRequest(`${API}/delivery-dashboard/order-positions/`, params),
          this.makeRequest(`${API}/delivery-dashboard/order-linked-lbs/`, params),
        ])
        const positions = (pos.data.results || []).filter(this.isStockPosition)
        const linkedLbs = lbs.data.results || []
        const lines = positions.map(p => this.incomingPositionLine(p, linkedLbs))
        this.$set(this.incomingCache, orderNo, { loading: false, error: false, lines })
      } catch (error) {
        this.$set(this.incomingCache, orderNo, { loading: false, error: true, lines: [] })
      }
    },
    // Server partial-delivery verdict as text; a delayed position without a
    // future supplier date makes the latest arrival unknown.
    partialLabel(item) {
      const latest = item.incoming_state === 'incoming' ? dateFmt(item.incoming_date) : this.$t('delivery.partial.noSupplierDate')
      const actionKey = PARTIAL_ACTION_KEYS[item.partial_action]
      const params = {
        action: actionKey ? this.$t(`delivery.partial.${actionKey}`) : '', ready: item.ready_positions, delayed: item.delayed_positions, latest,
      }
      return this.$t(actionKey ? 'delivery.partial.label' : 'delivery.partial.labelNoAction', params)
    },
    // Export label for the Incoming column (exportList) — same states as the
    // on-screen cell, flattened to plain text. is_closed only exists on S1 rows.
    incomingExportLabel(item) {
      if (item.is_closed || !item.incoming_state) return '—'
      if (item.incoming_state === 'incoming') return dateFmt(item.incoming_date)
      const lb = item.incoming_lb_no ? ` (${item.incoming_lb_no})` : ''
      return {
        stock: this.$t('delivery.states.inStock'),
        unconfirmed: `${this.$t('delivery.states.unconfirmed')}${lb}`,
        supplier_overdue: `${this.$t('delivery.states.supplierOverdue')}${lb}`,
        needs_purchasing: this.$t('delivery.states.notOrdered'),
      }[item.incoming_state] || '—'
    },
    // Highlight linked-LB rows whose delivery date is after the order's promised
    // date (the arrivals that make us late).
    lbRowClass(item) {
      if (!item || !this.originalPromisedDate || !item.delivery_date) return ''
      return String(item.delivery_date).slice(0, 10) > this.originalPromisedDate ? 'table-danger' : ''
    },
    // Row-click → open the detail modal. type is 'order' (S1/S2 customer orders)
    // or 'lb' (E1/E2/E3 supplier orders). Data is fetched on @shown.
    openDetail(type, item) {
      if (!item || !item.order_no) return
      this.detail.type = type
      this.detail.orderNo = item.order_no
      this.detail.header = {}
      this.detail.positions = []
      this.detail.linkedLbs = []
      // Server partial-delivery verdict of the clicked S1/S2 row (absent elsewhere).
      this.detail.partial = item.partial_delivery ? item : null
      this.$refs.detailModal.show()
    },
    async onDetailShown() {
      this.detail.loading = true
      try {
        const params = { order_no: this.detail.orderNo }
        if (this.detail.type === 'order') {
          const [d, pos, lbs] = await Promise.all([
            this.makeRequest(`${API}/delivery-dashboard/order-detail/`, params),
            this.makeRequest(`${API}/delivery-dashboard/order-positions/`, params),
            this.makeRequest(`${API}/delivery-dashboard/order-linked-lbs/`, params),
          ])
          this.detail.header = (d.data.results && d.data.results[0]) || {}
          this.detail.positions = pos.data.results || []
          this.detail.linkedLbs = lbs.data.results || []
          // Never seed the picker with the suggestion: a filled picker read as
          // "date already set" while JTL had none (Lukas, SB45058).
          const raw = this.detail.header.delivery_date || ''
          this.originalPromisedDate = raw ? String(raw).slice(0, 10) : ''
          this.editPromisedDate = this.originalPromisedDate
          this.editPriority = this.detail.header.priority
          // Prefill the editable notes from the loaded header.
          this.originalNote = this.detail.header.note || ''
          this.originalComment = this.detail.header.comment || ''
          this.editNote = this.originalNote
          this.editComment = this.originalComment
        } else {
          const [d, pos] = await Promise.all([
            this.makeRequest(`${API}/delivery-dashboard/lb-detail/`, params),
            this.makeRequest(`${API}/delivery-dashboard/lb-positions/`, params),
          ])
          this.detail.header = (d.data.results && d.data.results[0]) || {}
          this.detail.positions = pos.data.results || []
          // Prefill the editable date picker (normalise to YYYY-MM-DD so it
          // matches flatPickr's value and the change-detection compares cleanly).
          const raw = this.detail.header.delivery_date || ''
          this.editDeliveryDate = raw ? String(raw).slice(0, 10) : ''
          this.originalDeliveryDate = this.editDeliveryDate
          // Prefill the editable LB internal comment (cInternerKommentar).
          this.originalComment = this.detail.header.comment || ''
          this.editComment = this.originalComment
        }
      } finally {
        this.detail.loading = false
      }
    },
    resetDetail() {
      this.detail.header = {}
      this.detail.positions = []
      this.detail.linkedLbs = []
      this.editDeliveryDate = ''
      this.originalDeliveryDate = ''
      this.savingDate = false
      this.editPromisedDate = ''
      this.originalPromisedDate = ''
      this.savingPromisedDate = false
      this.editPriority = null
      this.savingPriority = false
      this.editReason = ''
      this.editReasonNote = ''
      this.editNote = ''
      this.editComment = ''
      this.originalNote = ''
      this.originalComment = ''
      this.savingNotes = false
      this.appendingNote = false
      this.newCommentLine = ''
      this.addingComment = false
    },
    // Save the edited supplier-LB delivery date back to JTL. Reuses the existing
    // update-suporder-delivery-date endpoint (now also updates the positions, so
    // the dashboard's latest-position date reflects the change). Empty -> clears it.
    async saveLbDeliveryDate() {
      if (!this.detail.header.order_pk) return
      this.savingDate = true
      try {
        await axios.post(`${API}/update-suporder-delivery-date/`, {
          order_pk: this.detail.header.order_pk,
          delivery_date: this.editDeliveryDate || null,
          source: DASHBOARD_SOURCE,
        }, {
          headers: { Authorization: `JWT ${this.$store.state.jwt}`, 'Content-Type': 'application/json' },
        })
        this.showToast('success', this.$t('deliveryModal.toast.lbDateSaved'))
        // Refresh the modal (header + positions) and the lists/summary behind it.
        await this.onDetailShown()
        await this.refreshAll()
      } catch (error) {
        this.showToast('danger', this.$t('deliveryModal.toast.lbDateError'))
      } finally {
        this.savingDate = false
      }
    },
    // Save the LB internal comment (cInternerKommentar) back to JTL via the existing
    // update-suporder-notes endpoint. Reloads the header so any auto-appended
    // delivery-date history shows up.
    async saveLbNotes() {
      if (!this.detail.header.order_pk) return
      this.savingNotes = true
      try {
        await axios.post(`${API}/update-suporder-notes/`, {
          order_pk: this.detail.header.order_pk,
          notes: this.editComment || '',
          source: DASHBOARD_SOURCE,
        }, {
          headers: { Authorization: `JWT ${this.$store.state.jwt}`, 'Content-Type': 'application/json' },
        })
        this.showToast('success', this.$t('deliveryModal.toast.notesSaved'))
        await this.onDetailShown()
      } catch (error) {
        this.showToast('danger', this.$t('deliveryModal.toast.notesError'))
      } finally {
        this.savingNotes = false
      }
    },
    // Save the edited promised delivery date for a customer order back to JTL
    // (tAuftrag.dVoraussichtlichesLieferdatum). Empty -> clears it.
    // source: 'manual' (picker + Save), 'quick' (+N buttons) or 'suggestion'
    // (applying the tool's own suggestion — no reason required by the backend).
    // extra merges additional fields into the payload (e.g. suggestion_reason).
    async saveOrderPromisedDate(source = 'manual', extra = {}) {
      if (!this.detail.orderNo) return
      this.savingPromisedDate = true
      try {
        await axios.post(`${API}/update-order-promised-delivery/`, {
          order_no: this.detail.orderNo,
          delivery_date: this.editPromisedDate || null,
          source,
          reason: this.editReason,
          reason_note: this.editReasonNote.trim(),
          ...extra,
        }, {
          headers: { Authorization: `JWT ${this.$store.state.jwt}`, 'Content-Type': 'application/json' },
        })
        this.showToast('success', this.$t('deliveryModal.toast.promisedSaved'))
        this.editReason = ''
        this.editReasonNote = ''
        // Refresh the modal (header) and the lists/summary behind it.
        await this.onDetailShown()
        await this.refreshAll()
      } catch (error) {
        if (error.response && error.response.status === 400 && error.response.data
          && error.response.data.errors && error.response.data.errors.reason) {
          this.showToast('danger', this.$t('deliveryModal.toast.chooseReasonChange'))
        } else {
          this.showToast('danger', this.$t('deliveryModal.toast.promisedError'))
        }
      } finally {
        this.savingPromisedDate = false
      }
    },
    // Saves on select change; the backend also prepends a cHinweis history line.
    async saveOrderPriority(priority) {
      // vue-select emits input even when the same option is re-picked.
      if (!this.detail.orderNo || priority === this.detail.header.priority) return
      this.savingPriority = true
      try {
        await axios.post(`${API}/delivery-dashboard/update-order-priority/`, {
          order_no: this.detail.orderNo,
          priority,
        }, {
          headers: { Authorization: `JWT ${this.$store.state.jwt}`, 'Content-Type': 'application/json' },
        })
        this.showToast('success', this.$t('deliveryModal.toast.prioritySaved'))
        await this.onDetailShown()
        await this.refreshAll()
      } catch (error) {
        this.editPriority = this.detail.header.priority
        this.showToast('danger', this.$t('deliveryModal.toast.priorityError'))
      } finally {
        this.savingPriority = false
      }
    },
    // ===================== AUTO-APPLY (S2 24h auto-apply) =====================
    // Info-line counts/state above the S2 table. Non-critical — a failure here
    // shouldn't toast over the list refresh that triggered it, so it just keeps
    // whatever was last shown.
    async fetchAutoApplyStatus() {
      try {
        const res = await this.makeRequest(`${API}/delivery-dashboard/auto-apply-status/`, {})
        const d = res.data || {}
        this.autoApply = {
          enabled: !!d.enabled,
          delayHours: d.delay_hours || 24,
          counts: d.counts || { pending: 0, skipped: 0, rejected: 0 },
          lastRunAt: d.last_run_at || '',
        }
      } catch (error) { /* keep previous state; the S2 list itself still loaded */ }
    },
    // Toggle the "skipped & rejected" review card; fetch its rows only when
    // opening (not persisted, so it never fetches on plain page load).
    async toggleAutoQueue() {
      this.showAutoQueue = !this.showAutoQueue
      if (this.showAutoQueue) await this.fetchAutoQueue()
    },
    async fetchAutoQueue() {
      this.autoQueue.loading = true
      try {
        const res = await this.makeRequest(`${API}/delivery-dashboard/auto-apply-queue/`, { status: 'skipped,rejected' })
        this.autoQueue.items = res.data.results || []
      } catch (error) {
        this.showToast('danger', this.$t('deliveryModal.toast.queueError'))
      } finally {
        this.autoQueue.loading = false
      }
    },
    // Skip-reason code -> label (only two codes exist server-side).
    autoSkipLabel(code) {
      return this.$te(`delivery.auto.skipReason.${code}`) ? this.$t(`delivery.auto.skipReason.${code}`) : (code || '')
    },
    // Rejected-reason code -> label. Reuses DATE_CHANGE_REASON_CODES (dateChangeReasons)
    // per the agreed reason set, same as the manual-change reason picker.
    // Translate by code; the backend-supplied label is only the fallback for unknown codes.
    rejectedReasonLabel(code, fallback = '') {
      return this.$te(`delivery.reasons.${code}`) ? this.$t(`delivery.reasons.${code}`) : (fallback || code || '')
    },
    // Hover title for a "Rejected" badge: by/at (S2 rows carry no note field —
    // that's only on the review-card queue rows).
    rejectedTitle(item) {
      const parts = []
      if (item.auto_rejected_by) parts.push(this.$t('delivery.auto.rejectedBy', { name: item.auto_rejected_by }))
      if (item.auto_rejected_at) parts.push(this.$t('delivery.auto.rejectedAt', { date: dateTimeFmt(item.auto_rejected_at) }))
      return parts.join(' ')
    },
    // Opens the shared reject-suggestion modal for orderNo (S2 row, order-modal
    // pending line, or review-card row — all funnel through this one modal).
    openRejectModal(orderNo) {
      this.rejectTarget = { orderNo, reason: '', note: '' }
      this.$refs.rejectModal.show()
    },
    async submitReject(bvModalEvt) {
      if (bvModalEvt) bvModalEvt.preventDefault()
      if (!this.rejectTarget.reason) return
      this.rejecting = true
      try {
        await axios.post(`${API}/delivery-dashboard/reject-suggestion/`, {
          order_no: this.rejectTarget.orderNo,
          reason: this.rejectTarget.reason,
          reason_note: this.rejectTarget.note.trim(),
        }, {
          headers: { Authorization: `JWT ${this.$store.state.jwt}`, 'Content-Type': 'application/json' },
        })
        this.showToast('success', this.$t('deliveryModal.toast.suggestionRejected', { no: this.rejectTarget.orderNo }))
        this.$refs.rejectModal.hide()
        await this.getList('s2')
      } catch (error) {
        if (error.response && error.response.status === 400 && error.response.data
          && error.response.data.errors && error.response.data.errors.reason) {
          this.showToast('danger', this.$t('deliveryModal.toast.chooseReason'))
        } else {
          this.showToast('danger', this.$t('deliveryModal.toast.rejectError'))
        }
      } finally {
        this.rejecting = false
      }
    },
    async unrejectSuggestion(orderNo) {
      try {
        await axios.post(`${API}/delivery-dashboard/unreject-suggestion/`, { order_no: orderNo }, {
          headers: { Authorization: `JWT ${this.$store.state.jwt}`, 'Content-Type': 'application/json' },
        })
        this.showToast('success', this.$t('deliveryModal.toast.rejectionUndone', { no: orderNo }))
        await this.getList('s2')
      } catch (error) {
        this.showToast('danger', this.$t('deliveryModal.toast.undoError'))
      }
    },
    // One-click apply of the suggested promised date from an S2 row. Reuses the
    // promised-delivery endpoint (which appends the audit line to cHinweis), so it
    // behaves exactly like saving the same date from the modal.
    async applySuggestion(item) {
      if (!item || !item.suggested_date) return
      this.applyingOrderNo = item.order_no
      try {
        await axios.post(`${API}/update-order-promised-delivery/`, {
          order_no: item.order_no,
          delivery_date: String(item.suggested_date).slice(0, 10),
          source: 'suggestion',
          suggestion_reason: item.suggestion_reason,
        }, {
          headers: { Authorization: `JWT ${this.$store.state.jwt}`, 'Content-Type': 'application/json' },
        })
        this.showToast('success', this.$t('deliveryModal.toast.promisedSavedFor', { date: dateFmt(item.suggested_date), no: item.order_no }))
        // The order leaves S2 (it now has a date) and shows up in S1.
        await this.refreshAll()
      } catch (error) {
        this.showToast('danger', this.$t('deliveryModal.toast.promisedError'))
      } finally {
        this.applyingOrderNo = ''
      }
    },
    // One-click apply of the modal suggestion: set the picker, then save through
    // the normal flow so the audit line is appended and everything refreshes.
    async applyModalSuggestion() {
      if (!this.modalSuggestion.date) return
      this.editPromisedDate = this.modalSuggestion.date
      // Applying the tool's own suggestion needs no reason — the backend skips
      // the reason-required check for source: 'suggestion'.
      await this.saveOrderPromisedDate('suggestion', { suggestion_reason: this.modalSuggestion.reason })
    },
    quickDate(n) {
      return addDaysYmd(this.quickDateBase, n)
    },
    todayYmd,
    // Quick "+N calendar days" buttons — one-click JTL-style shortcut: set the
    // picker to quickDateBase + n. This is a manual change, so it needs a reason like
    // any other: if one is already chosen, save immediately through the normal
    // flow (audit line + toast + refresh); otherwise just set the picker so the
    // reason row appears below it and wait for the user to pick one and Save.
    async applyQuickDate(n) {
      this.editPromisedDate = this.quickDate(n)
      if (this.editReason) {
        await this.saveOrderPromisedDate('quick')
      } else {
        this.showToast('warning', this.$t('deliveryModal.toast.chooseReasonThenSave'))
      }
    },
    // Append the German partial-delivery hint to the internal comment (cHinweis).
    // The append happens server-side, so concurrent comment edits are never
    // clobbered by a stale client copy.
    async notePartialDelivery() {
      const pd = this.partialDelivery
      if (!pd || !this.detail.orderNo) return
      this.appendingNote = true
      try {
        const rest = pd.remainderDate ? `Rest vsl. ${dateFmt(pd.remainderDate)}` : 'Rest unbestimmt'
        await axios.post(`${API}/append-order-comment/`, {
          order_no: this.detail.orderNo,
          line: `Teillieferung möglich: ${pd.available}/${pd.total} Positionen ab Lager, ${rest}`,
          source: DASHBOARD_SOURCE,
          kind: 'partial_delivery',
        }, {
          headers: { Authorization: `JWT ${this.$store.state.jwt}`, 'Content-Type': 'application/json' },
        })
        this.showToast('success', this.$t('deliveryModal.toast.noteAppended'))
        await this.onDetailShown()
      } catch (error) {
        this.showToast('danger', this.$t('deliveryModal.toast.noteError'))
      } finally {
        this.appendingNote = false
      }
    },
    // Prepend a stamped line to the internal comment (order: cHinweis, LB:
    // cInternerKommentar) server-side, then reload only the comment so other
    // unsaved modal edits survive.
    async addComment() {
      const line = this.newCommentLine.trim()
      if (this.addCommentDisabled) return
      const isLb = this.detail.type === 'lb'
      const [url, payload] = isLb
        ? [`${API}/delivery-dashboard/append-lb-comment/`, { order_pk: this.detail.header.order_pk, line }]
        : [`${API}/append-order-comment/`, {
          order_no: this.detail.orderNo, line, source: DASHBOARD_SOURCE, kind: 'comment',
        }]
      this.addingComment = true
      let saved = false
      try {
        await axios.post(url, payload, {
          headers: { Authorization: `JWT ${this.$store.state.jwt}`, 'Content-Type': 'application/json' },
        })
        saved = true
        this.showToast('success', this.$t('deliveryModal.toast.commentAdded'))
        this.newCommentLine = ''
        const detailUrl = `${API}/delivery-dashboard/${isLb ? 'lb-detail' : 'order-detail'}/`
        const d = await this.makeRequest(detailUrl, { order_no: this.detail.orderNo })
        const comment = ((d.data.results && d.data.results[0]) || {}).comment || ''
        this.$set(this.detail.header, 'comment', comment)
        this.originalComment = comment
        this.editComment = comment
      } catch (error) {
        this.showToast(saved ? 'warning' : 'danger', this.$t(saved ? 'deliveryModal.toast.commentReloadFailed' : 'deliveryModal.toast.commentError'))
      } finally {
        this.addingComment = false
      }
    },
    // Save the customer note (cAnmerkung) and internal comment (cHinweis) back to
    // JTL. Reloads the header afterwards so any auto-appended delivery-date history
    // shows up; no list refresh needed since notes don't affect the list rows.
    async saveOrderNotes() {
      if (!this.detail.orderNo) return
      this.savingNotes = true
      try {
        await axios.post(`${API}/update-order-notes/`, {
          order_no: this.detail.orderNo,
          note: this.editNote || null,
          comment: this.editComment || null,
          source: DASHBOARD_SOURCE,
        }, {
          headers: { Authorization: `JWT ${this.$store.state.jwt}`, 'Content-Type': 'application/json' },
        })
        this.showToast('success', this.$t('deliveryModal.toast.notesSaved'))
        await this.onDetailShown()
      } catch (error) {
        this.showToast('danger', this.$t('deliveryModal.toast.notesError'))
      } finally {
        this.savingNotes = false
      }
    },
    async exportList(key) {
      const params = this.listParams(key, { export: 'true' })
      const res = await this.makeRequest(this.endpoints[key], params)
      const fields = this.tableFields[key].filter(f => f.key !== 'actions' && f.key !== 'pos_summary' && f.key !== 'suggested' && f.key !== 'hold' && f.key !== 'incoming_date')
      const L = k => this.$t(`delivery.cols.${k}`)
      const X = k => this.$t(`deliveryModal.exp.${k}`)
      const rows = (res.data.results || []).map(r => {
        const o = {}
        // Notes get the raw untruncated value in the export — the 50-char
        // truncation is only for the on-screen table cell.
        fields.forEach(f => {
          if (f.key === 'notes') {
            o[f.label] = r.notes || ''
          } else {
            o[f.label] = f.formatter ? f.formatter(r[f.key]) : r[f.key]
          }
        })
        if (key === 's1' || key === 's2') {
          // Same rule set as the on-screen cell (incoming_date excluded from the
          // generic loop above, same as suggested/hold).
          o[X('incoming')] = this.incomingExportLabel(r)
          o[X('partial')] = r.partial_delivery ? this.partialLabel(r) : ''
          o[X('paidDate')] = dateFmt(r.paid_date)
        }
        if (key === 'e1') {
          o[X('posWithoutDate')] = `${r.pos_no_date}/${r.pos_total}`
          o[X('blocksLateOrder')] = r.blocked_order_no || ''
        }
        if (key === 's1') {
          // Override the generic Status/Due mappings above: the b-table cell for
          // 'status' is computed via statusLabel/bucket (not a raw item field),
          // and 'Due' must read as a dash for closed rows (formatters in the
          // generic loop above only receive the value, not the item).
          o[L('status')] = this.statusLabel(r)
          o[L('due')] = r.is_closed ? '—' : this.daysText(r.days_diff)
          o[X('lateSeverity')] = { 2: r.definitely_late ? X('definitelyLate') : X('overdue'), 1: X('supplierOverdue') }[r.late_severity] || ''
        }
        if (key === 's2') {
          const lb = r.suggestion_lb_no ? ` (${r.suggestion_lb_no})` : ''
          o[L('suggestedDate')] = dateFmt(r.suggested_date) || {
            unconfirmed: `${this.$t('delivery.states.orderedAwaiting')}${lb}`,
            supplier_overdue: `${this.$t('delivery.states.supplierOverdue')}${lb}`,
            needs_purchasing: this.$t('delivery.states.needsPurchasing'),
          }[r.suggestion_reason] || ''
          o[X('autoApply')] = {
            pending: this.$t('deliveryModal.exp.pending', { date: dateTimeFmt(r.auto_apply_at) }),
            skipped: this.$t('deliveryModal.exp.skipped', { reason: this.autoSkipLabel(r.auto_skip_reason) }),
            rejected: this.$t('deliveryModal.exp.rejected', { reason: this.rejectedReasonLabel(r.auto_rejected_reason) }),
          }[r.auto_status] || ''
        }
        if (key === 'e4') {
          // Override the generic 'suggestion_reason' -> Reason mapping above
          // with the same labels as the S2 badge cell (E4 only ever shows
          // needs_purchasing/supplier_overdue — never stock/unconfirmed).
          o[L('reason')] = {
            supplier_overdue: `${this.$t('delivery.states.supplierOverdue')}${r.suggestion_lb_no ? ` (${r.suggestion_lb_no})` : ''}`,
            needs_purchasing: this.$t('delivery.states.needsPurchasingNothingOrdered'),
          }[r.suggestion_reason] || ''
        }
        if (key === 's1' || key === 's2' || key === 'e4') {
          // hold_reason may arrive as 0 for NULL (fillna) — keep the export clean.
          o[X('onHold')] = r.on_hold ? (r.hold_reason || this.$t('delivery.common.yes')) : ''
        }
        return o
      })
      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, key.toUpperCase())
      XLSX.writeFile(wb, `DeliveryDate_${key.toUpperCase()}.xlsx`)
    },
    // Traffic-light bucket from days_diff / no-date. Thresholds are configurable
    // here and could be lifted into the filter bar later. Closed/shipped rows
    // (S1, search-only) short-circuit to their own bucket before the date math.
    bucket(item) {
      if (item.is_closed) return 'closed'
      const d = item.days_diff
      if (d === null || d === undefined) return 'grey'
      if (d < 0) return 'red'
      if (d <= 1) return 'orange'
      if (d <= 7) return 'yellow'
      return 'green'
    },
    lightVariant(item) {
      return {
        grey: 'secondary', red: 'danger', orange: 'warning', yellow: 'warning', green: 'success', closed: 'secondary',
      }[this.bucket(item)]
    },
    // Order-age highlight (S1/S2, all sources) — very old orders must be visible
    // at a glance. '' (falsy) means "plain number, no badge".
    ageVariant(days) {
      if (days === null || days === undefined || days === '') return ''
      if (days >= AGE_CRITICAL_DAYS) return 'danger'
      if (days >= AGE_WARN_DAYS) return 'warning'
      return ''
    },
    ageTooltip(item) {
      if (item.age_days === null || item.age_days === undefined || item.age_days === '') return ''
      const n = Number(item.age_days)
      return item.order_date
        ? this.$tc('delivery.age.tooltipSince', n, { n, date: dateFmt(item.order_date) })
        : this.$tc('delivery.age.tooltip', n, { n })
    },
    // Label for a closed/shipped row (S1 only) — credited/shipped(+date)/delivered.
    closedLabel(item) {
      if (item.closed_reason === 'credited') return this.$t('delivery.closed.credited')
      if (item.closed_reason === 'shipped' && item.shipped_date) return this.$t('delivery.closed.shipped', { date: dateFmt(item.shipped_date) })
      return this.$t('delivery.closed.delivered')
    },
    statusLabel(item) {
      if (item.is_closed) return this.closedLabel(item)
      return this.$t(`delivery.bucket.${this.bucket(item)}`)
    },
    priorityVariant(p) {
      if (p >= 4) return 'light-danger'
      if (p >= 1) return 'light-warning'
      if (p < 0) return 'light-secondary'
      return ''
    },
    paymentVariant(status) {
      return {
        paid: 'light-success', partial: 'light-warning', unpaid: 'light-danger',
      }[status] || 'light-secondary'
    },
    paymentLabel(status) {
      return this.$te(`delivery.payment.${status}`) ? this.$t(`delivery.payment.${status}`) : '—'
    },
    e2RowClass(item) {
      if (item && item.days_since_ordered > this.daysNoDate) return 'table-danger'
      return ''
    },
    // Late customer orders (promise passed, or supplier delivery dated after the promise).
    // Closed/shipped rows (search-only) read as inactive instead.
    s1RowClass(item) {
      if (item && item.is_closed) return 'text-muted'
      if (item && item.late_severity === 2) return 'table-danger'
      return ''
    },
    // LBs that are themselves overdue AND hold up a late customer order — the
    // rows purchasing must chase first.
    e1RowClass(item) {
      if (item && item.blocks_late_order && item.days_diff !== null && item.days_diff < 0) return 'table-danger'
      return ''
    },
    copy(text) {
      if (navigator.clipboard) navigator.clipboard.writeText(text)
      this.showToast('success', this.$t('deliveryModal.toast.copied', { text }))
    },
    showToast(variant, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: text,
          icon: variant === 'danger' ? 'AlertTriangleIcon' : 'CheckCircleIcon',
          variant,
        },
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";

#delivery-date-dashboard {

  // Card-header: title on its own line, subtitle stacked beneath it,
  // the export icon kept on the top-right. (card-header is a flex row,
  // so force the subtitle to a full-width line and order the icon first.)
  .card-header>div {
    order: 1;
  }

  .card-header>p {
    order: 2;
    flex: 0 0 100%;
    margin-top: 0.4rem;
  }

  .copy-no {
    cursor: pointer;
    font-weight: 600;
    color: #6e6b7b;
  }

  .copy-no:hover {
    color: #7367f0;
  }

  // E4 "waiting for purchasing" card header, when it currently holds rows —
  // a red left border + faint tint so it reads as needing action at a glance.
  .critical-header {
    border-left: 4px solid #ea5455;
    background-color: rgba(234, 84, 85, 0.08);
    padding-left: calc(1.5rem - 4px);
  }

  // Transient highlight for tables scrolled-to from a KPI card that has no filter
  // of its own to apply (support_no_date -> S2, lb_unconfirmed -> E2).
  .flash-highlight {
    animation: dd-flash 2s ease-out;
  }

  // Whole-row click affordance for the lists that open the detail modal.
  .clickable-rows tbody tr {
    cursor: pointer;
  }

  // Label / value pairs inside the detail modal.
  .detail-label {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #b9b9c3;
    margin-bottom: 0.15rem;
  }

  .detail-value {
    font-weight: 500;
  }

  .detail-note {
    white-space: pre-wrap;
    background: #f8f8f8;
    border-radius: 0.357rem;
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }

  // Inline delivery-date editor: plain flex row (NOT a Bootstrap input-group, whose
  // own rounding rules the flatpickr input escapes) — the picker grows, the Save
  // button hugs it, and the touching corners are squared so they read as one control.
  .delivery-date-edit {
    .form-control {
      flex: 1 1 auto;
      min-width: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .btn {
      flex: 0 0 auto;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}

// Top-level: @keyframes cannot be nested inside a selector block in plain CSS.
@keyframes dd-flash {
  0% {
    box-shadow: 0 0 0 4px rgba(115, 103, 240, 0.6);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(115, 103, 240, 0);
  }
}
.stats-weeks-select {
  min-width: 140px;
}
// Incoming-column popover is portaled to <body>, so it cannot live under
// #delivery-date-dashboard. Wider than Bootstrap's 276px so "SKU × qty" and
// "overdue since … · LB…" stay on one line.
.incoming-popover {
  max-width: 440px;

  // Outline the whole popover in the header colour ($primary) — the theme only
  // colours the header and leaves the body with a faint grey border. Top border
  // stays as the theme sets it (the header sits there).
  .popover-body {
    border-right-color: #7367f0;
    border-bottom-color: #7367f0;
    border-left-color: #7367f0;
  }

  &.bs-popover-top > .arrow::before {
    border-top-color: #7367f0;
  }

  .incoming-popover-line {
    white-space: nowrap;
    font-size: 0.85rem;
  }
}
</style>
